import { fabric } from "fabric";

import _ from 'lodash';

import moment from "moment";

import ConfigGuestModalView from "../guests/configGuestModal.html";
import SearchGroupModalView from "../guests/searchGroupModal.html";
import PlaceNotAvailableActionModalView from "./spaces-place-not-available-action.html";
import SetFirstPositionModalView from "./spaces-set-first-position.html";
import SetZoneModalView from "./spaces-set-zone.html";
import FreePlaceActionModalView from "./spaces-free-place-action.html";
import SpaceItemTableModalView from "./spaces-item-table.html";
import SpaceItemZoneModalView from "./spaces-item-zone.html";
import SpaceItemVehicleModalView from "./spaces-item-vehicle.html";
import SpaceGuestGridTemplateView from "./cell-template-guest.html";
import SpacePlaceGridTemplateView from "./cell-template-place.html";

var CONFIG_TABLE = {
    CARTESIAN_4: [1, 4, 2, 3],
    CARTESIAN_5: [1, 5, 4, 2, 3],
    CARTESIAN_6: [1, 5, 4, 2, 6, 3],
    CARTESIAN_7: [1, 5, 4, 2, 6, 7, 3],
    CARTESIAN_8: [1, 5, 8, 4, 2, 6, 7, 3],
    CARTESIAN_9: [1, 5, 8, 4, 2, 6, 9, 7, 3],
    CARTESIAN_10: [1, 5, 9, 8, 4, 2, 6, 10, 7, 3],
    CARTESIAN_11: [1, 5, 9, 8, 4, 2, 6, 10, 11, 7, 3],
    CARTESIAN_12: [1, 5, 9, 12, 8, 4, 2, 6, 10, 11, 7, 3],
    CARTESIAN_13: [1, 5, 9, 12, 8, 4, 2, 6, 10, 13, 11, 7, 3],
    CARTESIAN_14: [1, 5, 9, 14, 12, 8, 4, 2, 6, 10, 13, 11, 7, 3],
    CLOCK_4: [1, 4, 2, 3],
    CLOCK_5: [1, 4, 5, 2, 3],
    CLOCK_6: [1, 4, 5, 2, 6, 3],
    CLOCK_7: [1, 4, 5, 2, 6, 7, 3],
    CLOCK_8: [1, 4, 8, 5, 2, 6, 7, 3],
    CLOCK_9: [1, 4, 8, 9, 5, 2, 6, 7, 3],
    CLOCK_10: [1, 4, 8, 9, 5, 2, 6, 7, 10, 3],
    CLOCK_11: [1, 4, 8, 9, 5, 2, 6, 7, 10, 11, 3],
    CLOCK_12: [1, 4, 8, 12, 9, 5, 2, 6, 10, 11, 7, 3],
    CLOCK_13: [1, 4, 8, 12, 13, 9, 5, 2, 6, 10, 11, 7, 3],
    CLOCK_14: [1, 4, 8, 12, 13, 9, 5, 2, 6, 10, 14, 11, 7, 3],
}
var CONFIG_TABLE_FRENCH = {
    CARTESIAN_4: [3, 1, 4, 2],
    CARTESIAN_5: [3, 1, 5, 2, 4],
    CARTESIAN_6: [3, 1, 5, 6, 2, 4],
    CARTESIAN_7: [7, 3, 1, 5, 4, 2, 6],
    CARTESIAN_8: [7, 3, 1, 5, 8, 4, 2, 6],
    CARTESIAN_9: [7, 3, 1, 5, 9, 8, 4, 2, 6],
    CARTESIAN_10: [7, 3, 1, 5, 9, 8, 4, 2, 6 ,10],
    CARTESIAN_11: [11, 7, 3, 1, 5, 9, 8, 4, 2, 6, 10],
    CARTESIAN_12: [11, 7, 3, 1, 5, 9, 12, 8, 4, 2, 6, 10],
    CARTESIAN_13: [11, 7, 3, 1, 5, 9, 13, 10, 6, 2, 4, 8, 12],
    CARTESIAN_14: [11, 7, 3, 1, 5, 9, 13, 12, 8, 4, 2, 6, 10, 14],
    CLOCK_4: [3, 1, 4, 2],
    CLOCK_5: [3, 1, 4, 5, 2],
    CLOCK_6: [3, 1, 4, 5, 2, 6],
    CLOCK_7: [7, 3, 1, 4, 5, 2, 6],
    CLOCK_8: [7, 3, 1, 4, 8, 5, 2, 6],
    CLOCK_9: [7, 3, 1, 4, 8, 9, 5, 2, 6],
    CLOCK_10: [7, 3, 1, 4, 8, 9, 5, 2, 6, 10],
    CLOCK_11: [11, 7, 3, 1, 4, 8, 9, 5, 2, 6, 10],
    CLOCK_12: [11, 7, 3, 1, 4, 8, 12, 9, 5, 2, 6, 10],
    CLOCK_13: [11, 7, 3, 1, 4, 8, 12, 13, 9, 5, 2, 6, 10],
    CLOCK_14: [11, 7, 3, 1, 4, 8, 12, 13, 9, 5, 2, 6, 10, 14],
}

angular.module("events")

    .directive("ngInject", ['$parse', '$interpolate', '$controller', '$compile', function ($parse, $interpolate, $controller, $compile) {
        return {
            terminal: true,
            transclude: true,
            priority: 510,
            link: function (scope, element, attrs, ctrls, transclude) {

                if (!attrs.ngController) {
                    element.removeAttr("ng-inject");
                    $compile(element)(scope);
                    return;
                }

                const controllerName = attrs.ngController;

                const newScope = scope.$new(false);

                const locals = $parse(attrs.ngInject)(scope);
                locals.$scope = newScope;

                const controller = $controller(controllerName, locals);
                element.data("ngControllerController", controller);

                element.removeAttr("ng-inject").removeAttr("ng-controller");
                $compile(element)(newScope);
                transclude(newScope, function (clone) {
                    element.append(clone);
                });
                // restore to hide tracks
                element.attr("ng-controller", controllerName);
            }
        };
    }])

    .controller("EventsSpacesEditCtrl", 
        ['$q', '$http', 'modalService', '$rootScope', '$scope', 'Restangular', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$timeout', 'LoginService', '$uibModalInstance', 'id', 'configuration', 'name', 'SpacesService', 'eventService', 'logService',
            function ($q, $http, modalService, $rootScope, $scope, Restangular, $uibModal, $filter, $translate, $stateParams, $state, $timeout, LoginService, $uibModalInstance, id, configuration, name, SpacesService, eventService, logService) {
        $scope.is_template = $stateParams.is_template == 'true';
                $scope.showGuestList = true;

        //guardamos todos los invitados del evento para poder filtrarlos localmente
        let allEventGuest = [];

        //calculamos alto disponible para canvas
        const availableHeight = window.innerHeight - 240;
        $scope.canvas_height = availableHeight + "px";
        
        $scope.spaceCanvasFullWidth = false;

        let guestsInfo = [];

        let inSpaceEvents = true;

        if ($state.current.name === "spaces.list") {
            $scope.showGuestList = false;
            //$scope.canvas_height = "800px";??
            inSpaceEvents = false;
            $scope.isDashboard = false;
        }
        else if ($state.current.name === "events.edit.spaces")
        {
            $scope.isDashboard = false; 
        }
        else if ($state.current.name === "dashboard_space.show") {
            $scope.isDashboard = true;
        }

        $scope.zone_color = "#f8d48a";
        $scope.place_color_free = "#e9e9e9";
        $scope.place_color_occuped = "#cccccc";

        Restangular.all('Configurations').getList({ code: "SPACE_ZONE_BACKGROUND_COLOR"}).then(function (configuration) {
            if(Array.isArray(configuration) && configuration.length > 0) {
                $scope.zone_color = configuration[0].value;
            } 
        });

        Restangular.all('Configurations').getList({ code: "SPACE_PLACE_FREE_COLOR"}).then(function (configuration) {
            if(Array.isArray(configuration) && configuration.length > 0) {
                $scope.place_color_free = configuration[0].value;
            }
        });

        Restangular.all('Configurations').getList({ code: "SPACE_PLACE_OCCUPPIED_COLOR"}).then(function (configuration) {
            if(Array.isArray(configuration) && configuration.length > 0) {
                $scope.place_color_occuped = configuration[0].value;
            }
        });
       
        $scope.spaceClass = "col-lg-12";
        $scope.guestsClass = "col-lg-12";
        $scope.selectedRows = [];
        $scope.search = {
            name_surnames: "",
            accreditation: "",
            not_allocated: null,
            groups: null,
            _sortBy: "prefered",
            position_name: "",
            confirmed: false,
            allocated: null
        };
        $scope.spaceOptions = function (options) {
            $scope.isDashboard = options.isDashboard;
            $scope.spaceClass = options.spaceClass;
            $scope.guestsClass = options.guestsClass;
            $rootScope.islogged = false;

        };
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_SPACE_WRITE");
                const eventId = $stateParams.id;
                $scope.spaceDTO = {
            id: id,
            name: name,
            width: 2000,
            height: 1000,
            useFullname: true,
            usePosition: false
        };
        $scope.space = {
            zoom: 1,
            items: []
        };
        $scope.canvas = null;


        loadGridEventSpaceGuest();

        const Direction = {
            LEFT: 0,
            UP: 1,
            RIGHT: 2,
            DOWN: 3
        };
        
        $scope.gridLines = [];
        $scope.gridGroup = null;

        function addGrid() {
            logService.debug('addGrid');
            if ($scope.gridGroup) return;
            let gridsize = 5;
            let gridoption = {
                stroke: "#666666",
                strokeWidth: 1,
                objectCaching: false
//                strokeDashArray: [5, 5]
            };
            for (let x = 1; x < ($scope.spaceDTO.width); x += 50) {
                $scope.gridLines.push(new fabric.Line([x, 0, x, $scope.spaceDTO.height], gridoption));
            }
            for (let x = 1; x < ($scope.spaceDTO.height); x += 50) {
                $scope.gridLines.push(new fabric.Line([0, x, $scope.spaceDTO.width, x], gridoption));
            }
            $scope.gridGroup = new fabric.Group($scope.gridLines, {
                selectable: false,
                evented: false,
                objectCaching: false
            })
            $scope.gridGroup.addWithUpdate();
            $scope.canvas.add($scope.gridGroup);
            $scope.canvas.sendToBack($scope.gridGroup);
        }

        function removeGrid() {
            $scope.gridGroup && $scope.canvas.remove($scope.gridGroup);
            $scope.gridLines = [];
            $scope.gridGroup = null;
        }

        $scope.setCanvasWidth = function() {
            resizeCanvas(true);
        }
        
        $scope.setCanvasHeight = function() {
            resizeCanvas(true);
        }
        
        function moveSelected(direction, rotate = false) {
            let activeObject = $scope.canvas.getActiveObject();
            if (activeObject) {
                switch (direction) {
                    case Direction.LEFT:
                        if(rotate) {
                            activeObject.angle -= $scope.angleStep;
                        } else {
                            activeObject.left -= $scope.step;
                        }
                        break;
                    case Direction.UP:
                        activeObject.top -= $scope.step;
                        break;
                    case Direction.RIGHT:
                        if(rotate) {
                            activeObject.angle += $scope.angleStep;
                        } else {
                            activeObject.left += $scope.step;
                        }
                        break;
                    case Direction.DOWN:
                        activeObject.top += $scope.step;
                        break;
                }
                activeObject.setCoords();
                $scope.canvas.renderAll();
            } else {
                logService.debug('no object selected');
            }
        }

        $scope.init = function () {
            $scope.canvas = new fabric.Canvas('spaceCanvas');
            
            $scope.canvas.preserveObjectStacking = true;
            (window as any)._canvas = $scope.canvas;

            // Listen to double click event on canvas element
            $($scope.canvas.upperCanvasEl).dblclick(function (e, self) {
                const target = $scope.canvas.findTarget(e);
                if (target) {
                    $scope.onObjectDblClick(target);
                } else {
                    //dblclick fuera de objeto
                }
            });

            $scope.canvas.on('mouse:over', $scope.onMouseOver);

            $scope.canvas.on('mouse:wheel', function(opt) {
                const delta = opt.e.deltaY;
                let zoom = $scope.canvas.getZoom();
                zoom *= 0.999 ** delta;
                if (zoom > 20) zoom = 20;
                if (zoom < 0.01) zoom = 0.01;
                $scope.canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
                $scope.space.zoom = $scope.canvas.getZoom();
                opt.e.preventDefault();
                opt.e.stopPropagation();
            });

            $scope.canvas.on('mouse:down', function(opt) {
                let evt = opt.e;
                if (evt.altKey === true) {
                    this.isDragging = true;
                    this.selection = false;
                    this.lastPosX = evt.clientX;
                    this.lastPosY = evt.clientY;
                }
            });

            $scope.canvas.on('mouse:move', function(opt) {
                if (this.isDragging) {
                    const e = opt.e;
                    const vpt = this.viewportTransform;
                    vpt[4] += e.clientX - this.lastPosX;
                    vpt[5] += e.clientY - this.lastPosY;
                    this.requestRenderAll();
                    this.lastPosX = e.clientX;
                    this.lastPosY = e.clientY;
                }
            });
            $scope.canvas.on('mouse:up', function(opt) {
                // on mouse up we want to recalculate new interaction
                // for all objects, so we call setViewportTransform
                this.setViewportTransform(this.viewportTransform);
                this.isDragging = false;
                this.selection = true;
            });

/*            $scope.canvas.on('object:moving', function(options) {
                let grid = 50;
                logService.debug(options.target.left);
                logService.debug(options.target.top);
                if (Math.round(options.target.left / grid * 4) % 4 == 0 &&
                    Math.round(options.target.top / grid * 4) % 4 == 0) {
                    options.target.set({
                        left: Math.round(options.target.left / grid) * grid,
                        top: Math.round(options.target.top / grid) * grid
                    }).setCoords();
                }
            });*/

            fabric.util.addListener(document.body, 'keydown', function (options) {
                let key = options.which || options.keyCode; // key detection
                if (key === 37) { // handle Left key
                    moveSelected(Direction.LEFT, options.altKey);
                } else if (key === 38) { // handle Up key
                    moveSelected(Direction.UP);
                } else if (key === 39) { // handle Right key
                    moveSelected(Direction.RIGHT, options.altKey);
                } else if (key === 40) { // handle Down key
                    moveSelected(Direction.DOWN);
                }
            });
            
            $scope.step = 5;
            $scope.angleStep = 5;

            initFabricControls();
            
            $scope.canvas.calcOffset();
        };
        
        function initFabricControls() {
            let deleteImg = document.createElement('img');
            deleteImg.src = 'assets/img/spaces/icons/delete.svg';

            let sendBackImg = document.createElement('img');
            sendBackImg.src = 'assets/img/spaces/icons/arrow-down-double.svg';

            let sendFrontImg = document.createElement('img');
            sendFrontImg.src = 'assets/img/spaces/icons/arrow-up-double.svg';

            let goUpImg = document.createElement('img');
            goUpImg.src = 'assets/img/spaces/icons/arrow-up.svg';

            let goDownImg = document.createElement('img');
            goDownImg.src = 'assets/img/spaces/icons/arrow-down.svg';

            fabric.Object.prototype.controls.deleteControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 136,
                offsetX: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: deleteObject,
                render: renderIcon(deleteImg),
                cornerSize: 24
            });

            fabric.Object.prototype.controls.sendToFrontControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 8,
                offsetX: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: sendToFrontObject,
                render: renderIcon(sendFrontImg),
                cornerSize: 24
            });

            fabric.Object.prototype.controls.goUpControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 40,
                offsetX: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: goUpObject,
                render: renderIcon(goUpImg),
                cornerSize: 24
            });

            fabric.Object.prototype.controls.goDownControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 72,
                offsetX: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: goDownObject,
                render: renderIcon(goDownImg),
                cornerSize: 24
            });

            fabric.Object.prototype.controls.sendToBackControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 104,
                offsetX: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: sendToBackObject,
                render: renderIcon(sendBackImg),
                cornerSize: 24
            });            
        }

        function deleteObject(eventData, transform) {
            $scope.deleteObject(transform.target);
        }

        function sendToBackObject(eventData, transform) {
            $scope.sendToBack(transform.target);
        }

        function goDownObject(eventData, transform) {
            $scope.canvas.sendBackwards(transform.target);
        }

        function goUpObject(eventData, transform) {
            $scope.canvas.bringForward(transform.target, true);
        }

        function sendToFrontObject(eventData, transform) {
            $scope.canvas.bringToFront(transform.target);
        }
        
        function renderIcon(icon) {
            return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
                const size = this.cornerSize;
                ctx.save();
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.drawImage(icon, -size/2, -size/2, size, size);
                ctx.restore();
            }
        }

        function removeBox() {

            //quitamos el box
            $scope.canvas._objects.forEach(function (obj) {
                if(obj.localType == 'box') {
                    $scope.canvas.remove(obj);
                }
            });


            if($scope.gridShown) {
                removeGrid();
            }
        }
        
        function addBox() {

            //si hay un box de antes, lo quitamos
            removeBox();

            if($scope.gridShown) {
                addGrid();
            }

            /*let lines = [];
            // Top line
            lines.push(new fabric.Line([0, 0, $scope.spaceDTO.width, 0], { strokeWidth: 4, stroke: '#000000' }));

            // Left line
            lines.push(new fabric.Line([0, 0, 0, $scope.spaceDTO.height ], { strokeWidth: 4, stroke: '#000000' }));

            // Right line
            lines.push(new fabric.Line([$scope.spaceDTO.width, 0, $scope.spaceDTO.width, $scope.spaceDTO.height], { strokeWidth: 4, stroke: '#000000' }));

            // Bottom line
            lines.push(new fabric.Line([0, $scope.spaceDTO.height, $scope.spaceDTO.width, $scope.spaceDTO.height], { strokeWidth: 4, stroke: '#000000' }));*/

            let w = parseInt($scope.spaceDTO.width);
            let h = parseInt($scope.spaceDTO.height);

            let rect = new fabric.Rect({
                left: 0,
                top: 0,
                width: w,
                height: h,
                fill: '',
                stroke: '#000000',
                strokeWidth: 4
            });
            
            let box = new fabric.Group([rect], {
                localType: 'box',
                selectable: false,
                evented: false,
                objectCaching: false,
                draggable: false
            })
            $scope.canvas.add(box);
            $scope.canvas.sendBackwards(box);
        }
        
        function resizeCanvas(clean = false) {
            if (clean) {
                removeBox();
            }
            
            if($scope.spaceDTO.width == undefined) {
                $scope.spaceDTO.width = 2000;
            }
            if($scope.spaceDTO.height == undefined) {
                $scope.spaceDTO.height = 1000;
            }
//            $scope.canvas.setWidth($scope.spaceDTO.width);
//            $scope.canvas.setHeight($scope.spaceDTO.height);
            $scope.canvas.calcOffset();
            
            if(clean) {
                addBox();
            }
        }

        $scope.drawSpace = function (clean) {
            $timeout(function () {
                $scope.canvas.clear();
                angular.forEach($scope.space.items, function (item) {
                    let skip = false;

                    //si es un box viejo lo omitimos
                    if(item.type == 'group' && item._objects?.length==4 && item._objects[0].type=='line' && item._objects[0].strokeWidth == 4) skip = true;

                    if (!skip) (window as any)._canvas.add(item);

                });
                resizeCanvas(true);
            }, 200);

        };

        $scope.keepaliveInterval = null;
        $scope.keepalive = function () {
            if ($scope.spaceDTO.id != null && $scope.spaceDTO.event_id != null) {
                Restangular.one('eventsspaces/' + $scope.spaceDTO.event_id + "/edit/" + $scope.spaceDTO.id + "/keepalive").get().then(function (results) {
                });
            }
            $scope.keepaliveInterval = setTimeout(function () {
                $scope.keepalive();
            }, 20 * 1000);
        };

        $scope.$on("$destroy", function () {
            if ($scope.keepaliveInterval!=null) clearTimeout($scope.keepaliveInterval);
        });

        //cargamos espacio
        $timeout(function () {
            $scope.init();
            if (id !== null && typeof (id) !== "undefined") {
                let apiPath = 'eventsspaces/' + eventId + "/edit/";
                //si es plantilla cargamos de plantillas
                if (!$scope.showGuestList) apiPath = 'spaces/';
                Restangular.one(apiPath, id).get().then(function (results) {
                    $scope.spaceDTO = results;

                    if ($scope.showGuestList) {
                        //comprobamos si lo esta editando otro usuario
                        if ($scope.spaceDTO.last_edit_date != null) {
                            const diff = moment().diff($scope.spaceDTO.last_edit_date, "seconds");
                            if (diff < 30 && ($scope.spaceDTO.modified_by + "") != localStorage.getItem("userId")) {
                                modalService.message({
                                    title: $filter('translate')('events.spaces.error_only_one_user_title'),
                                    message: $filter('translate')('events.spaces.error_only_one_user'),
                                    onAccept: function () { }
                                });
                                $uibModalInstance.dismiss('cancel');
                                return;
                            }
                        }

                        //registramos keepalive
                        $scope.keepalive();
                    }

                    $scope.spaceDTO.configuration = JSON.parse($scope.spaceDTO.configuration);
                    $scope.space = $scope.spaceDTO.configuration;
                    $scope.canvas.setZoom($scope.space.zoom);
                    if($scope.space.viewportTransform!=null) $scope.canvas.setViewportTransform($scope.space.viewportTransform);
                    $scope.space.items = [];
                    $scope.canvas.loadFromJSON($scope.space.canvas, function () {
                    }, function (o, object) {
                        $scope.space.items.push(object);
                    });
                    $scope.drawSpace(true);
                }, function (error) {
                    logService.error(error);
                    let errorMessage = "Error desconocido";
                    if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                    toastr.error(errorMessage);
                });
                
            } else {
                $scope.spaceDTO.event_id = $stateParams.id;

                //Miramos si viene del template:
                if (configuration != "") {
                    $scope.spaceDTO.configuration = JSON.parse(configuration);
                    $scope.space = $scope.spaceDTO.configuration;
                    $scope.canvas.setZoom($scope.space.zoom);
                    $scope.space.items = [];
                    $scope.canvas.loadFromJSON($scope.space.canvas, function () {
                    }, function (o, object) {
                        $scope.space.items.push(object);
                    });
                    $scope.drawSpace(true);
                } else {
                    resizeCanvas();
                    $scope.space = {
                        zoom: 1,
                        items: []
                    };
                }
            }
        }, 2000);
        
        //menu contextual de spacio
        $scope.contextMenuOptions = [
            {
                text: 'Añadir zona',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    $scope.createZone(null, $event.offsetX, $event.offsetY);
                }
            },
            {
                text: 'Añadir mesa',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    $scope.createTable(null, $event.offsetX, $event.offsetY);
                }
            },
            {
                text: 'Añadir vehículo',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    $scope.createVehicle(null, $event.offsetX, $event.offsetY);
                }
            },
            null,
            {
                text: 'Enviar al fondo',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    if ($scope.canvas.getActiveObject() != null) $scope.sendToBack($scope.canvas.getActiveObject());
                    $scope.canvas.discardActiveObject();
                }
            }, //separador
            {
                text: 'Eliminar elemento seleccionado',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    if ($scope.canvas.getActiveObject() != null) $scope.deleteObject($scope.canvas.getActiveObject());
                    $scope.canvas.discardActiveObject();
                }
            }
        ];

        $scope.blinkPlaceIterations = 14;
        $scope.blinkPlace = function (place, color_guest) {
            //enceder rojo, normal cada 500ms
            if (place.fill  == "red") {
                //place.setFill($scope.place_color_occuped);
                place.set('fill', color_guest);
            } else {
                place.set('fill', "red");
            }
            if (typeof place.blinkIterationNumber == "undefined" || place.blinkIterationNumber == 0) place.blinkIterationNumber = 0;
            place.blinkIterationNumber++;
            if ($scope.blinkPlaceIterations > place.blinkIterationNumber) {
                $timeout(function () { $scope.blinkPlace(place, color_guest); }, 350);
            } else {
                place.blinkIterationNumber = 0;
            }
            //renderizar
            $scope.canvas.renderAll();
        };

        $scope.blink = function (eventGuest) {
            const event_guest_id = eventGuest.id;
            const objs = $scope.canvas.getObjects();
            for (let i = 0; i < objs.length; i++) {
                const obj = objs[i];

                if (typeof obj.guests != "undefined") {
                    //buscar si esta dentro el invitado
                    for (let j = 0; j < obj.guests.length; j++) {
                        const guest = obj.guests[j];
                        if (guest.event_guest_id == event_guest_id) {
                            //buscar el asiento
                            for (let n = 0; n < obj._objects.length; n++) {
                                const place = obj._objects[n];
                                if (typeof place.options != "undefined") {
                                    if (place.options.zone_prefered == guest.prefered) {
                                        place.blinkIterationNumber = 0;
                                        $scope.blinkPlace(place, guest.color_guest);
                                        break;
                                    }
                                }
                            }
                            break;
                        }
                    }
                }

            }
        };

        //lista de invitados


        $scope.confirmationStatus = {
         pending: $filter('translate')('events.guests.pending'), 
         confirmed: $filter('translate')('events.guests.confirmed'), 
         rejected: $filter('translate')('events.guests.rejected'), 
         pending_approval: $filter('translate')('events.guests.pending_approval'), 
         manage_delegate: $filter('translate')('events.guests.manage_delegate'), 
         delegated: $filter('translate')('events.guests.delegated') 

        }

        function getFiteredGuests() {
            var localFilteredResults = allEventGuest.filter(function (guest) {
                let ret = true;

                if (ret && $scope.search.name_surnames != "") ret = guest.FK_events_guests_persons?.fullname?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes($scope.search.name_surnames.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                if (ret && $scope.search.position_name != "") {
                    if (guest.FK_events_guests_persons_positions?.FK_persons_positions_positions?.FK_positions_tl_positions.length > 0) {
                        let position = guest.FK_events_guests_persons_positions?.FK_persons_positions_positions?.FK_positions_tl_positions[0];
                        ret = position.male_description?.toLowerCase().includes($scope.search.position_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) || position.female_description?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes($scope.search.position_name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                    } else {
                        ret = false;
                    }
                }
                console.log($scope.search.name_surnames);
                if(ret && $scope.search.accreditation !=""){
                    ret = guest.FK_events_guests_events_guests_accreditations?.name?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes($scope.search.accreditation.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                }
                if (ret && $scope.search.confirmed == true) ret = guest.confirmation_status == "confirmed";
                if (ret && $scope.search.not_allocated == true) ret = guest.zone_prefered == null;
                if (ret && $scope.search.allocated == true) ret = guest.zone != null;
                if (ret && $scope.search.groups != null && $scope.search.groups.length > 0) {
                    let anyGroup = false;
                    //recorremos grupos
                    for (let i = 0; i < $scope.search.groups.length; i++) {
                        let group_id = $scope.search.groups[i];
                        if (group_id == guest.FK_events_guests_persons_positions?.FK_persons_positions_positions?.FK_positions_groups?.id) {
                            anyGroup = true;
                            break;
                        }
                    }
                    ret = anyGroup;
                }
                if (ret && $scope.search.positions != null && $scope.search.positions.length > 0) {
                    let anyPosition = false;
                    //recorremos grupos
                    for (let i = 0; i < $scope.search.positions.length; i++) {
                        let position_id = $scope.search.positions[i];
                        if (position_id == guest.FK_events_guests_persons_positions?.FK_persons_positions_positions?.id) {
                            anyPosition = true;
                            break;
                        }
                    }
                    ret = anyPosition;
                }

                //if(ret && $scope.search.positions != null && $scope.search.positions.length > 0) ret = $scope.search.positions.includes(guest.position_id);

                return ret;
            });

            // Hacemos el short de los invitados
            localFilteredResults = localFilteredResults.sort((a, b) => {
                switch ($scope.search._sortBy) {
                    case "name":
                        if (a.FK_events_guests_persons.surname.toUpperCase() < b.FK_events_guests_persons.surname.toUpperCase()) {
                            return -1;
                        }
                        break;
                    case "prefered":
                        if (a.article_10) {
                            if (a.FK_events_guests_persons_positions && b.FK_events_guests_persons_positions &&a.FK_events_guests_persons_positions.position_order_article_10 < b.FK_events_guests_persons_positions.position_order_article_10) {
                                return -1;
                            }
                        } else {
                            if (a.effective_position_order < b.effective_position_order) {
                                return -1;
                            }
                        }
                        break;
                    case "group":
                        if (a.FK_events_guests_persons_positions && b.FK_events_guests_persons_positions && a.FK_events_guests_persons_positions.FK_persons_positions_positions.FK_positions_groups.preferred_order < b.FK_events_guests_persons_positions.FK_persons_positions_positions.FK_positions_groups.preferred_order) {
                            return -1;
                        }
                        break;
                    case "prefered_position_zone":
                        if (a.zone_prefered < b.zone_prefered) {
                            return -1;
                        }
                }
            });

            //recolocamos acompañantes detras de la persona que acompañan
            let localFilteredResultsCompanions = localFilteredResults.filter(guest => guest.referrer_person_id!=null);
            let finalLocalFilteredResults = localFilteredResults.filter(guest => guest.referrer_person_id==null);
            //console.log(finalLocalFilteredResults);
            localFilteredResultsCompanions.forEach(companion => {
                //buscamos index del invitado al que acompaña
                let referredIdx = finalLocalFilteredResults.findIndex(guest => guest.person_id == companion.referrer_person_id);
                if(referredIdx>=0){
                    finalLocalFilteredResults.splice(referredIdx+1, 0, companion);
                }else{
                    console.warn("No se ha encontrado el invitado al que acompaña el acompañante "+companion.FK_events_guests_persons.fullname, companion.referrer_person_id);
                }
            });

            $scope.totalRows = finalLocalFilteredResults.length;    

            return finalLocalFilteredResults;

        }




        function loadGridEventSpaceGuest() {
            if ($scope.showGuestList) {

                logService.info('loadGridEventSpaceGuest');
                logService.debug('id: ' + id);
                logService.debug('event_id: ' + $stateParams.id);
                // $scope.zones = eventService.getSpaceZones($stateParams.id, id).$object;

                $scope.gridEventSpaceGuest = {
                    rowHeight:50,
                    pdfTitle: $filter('translate')('events.spaces.guests_title'),
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableSorting: false,
                    paginationPageSizes: [50, 100, 150],
                    enableSelectionBatchEvent: true,//para obtener los seleccionados
                    paginationPageSize: 50,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                        this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
                        this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                        this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
                        this.gridApi.edit.on.afterCellEdit($scope, function(rowEntity, colDef, newValue, oldValue) {
                            if(colDef.name === 'zone_prefered') {
                                $scope.freePlace(rowEntity);
                                guestsInfo = [];
                                rowEntity.name = getFullSeatName(rowEntity);
                                guestsInfo.push(rowEntity);
                                if(!checkBusyPlacesAndAssign(newValue, 1)) {
                                    rowEntity[colDef.name] = oldValue;
                                    checkBusyPlacesAndAssign(oldValue, 1);
                                    guestsInfo = [];
                                }
                            }
                            $scope.canvas.renderAll();
                            $scope.$apply();
                        });
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true, allowCellFocus: false },
                        {
                            enableCellEdit: false,
                            allowCellFocus : false,
                            name: 'name',
                            displayName: $filter('translate')('events.spaces.guest_name'),
                            enableFiltering: false,
                            enableHiding: false,
                            cellTemplate: SpaceGuestGridTemplateView,

                            //C: \Users\guill\Source\repos\stela\Stela.Frontend\src\app\events\spaces

                        },
                        {
                            name: 'zone_prefered',
                            field: 'zone_prefered',
                            displayName: $filter('translate')('events.spaces.prefered_position'),
                            enableFiltering: false,
                            width: 80,
                            cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope" style="text-align: right; margin-right: 5px;">{{ COL_FIELD }}</div>'
                        },
                        {
                            enableCellEdit: false,
                            allowCellFocus : false,
                            name: 'seat',
                            displayName: $filter('translate')('events.spaces.guest_zone'),
                            enableFiltering: false,
                            width: 150,
                            cellTemplate: SpacePlaceGridTemplateView                        
                        },
                        { name: 'zone_id', visible: false, enableHiding: false, exporterSuppressExport: true, allowCellFocus: false },
                    ],
                    getData: function (options) {
                        const deferred = $q.defer();

                        logService.debug('getting data')

                        //quitados filtros porque se aplican debajo en local
                        options.event_id = $stateParams.id;
                        //options.name_surnames = $scope.search.name_surnames;
                        options._sortBy = $scope.search._sortBy;
                        //options.allocated = ($scope.search.not_allocated == true ? false : null);
                        options.groups_ids = $scope.search.groups;
                        options.positions_ids = $scope.search.positions;
                        //options.position_name = $scope.search.position_name;
                        options.event_space_id = id ?? -1;
                        //options.confirmed = $scope.search.confirmed;
                        if(options._page==null) options._page = 1;
                        let _page = options._page-1;
                        let _pageSize = options._pageSize;
                        delete options._page;
                        delete options._pageSize;
                        if ($scope.isDashboard) options.allocated = true;

                        //subimos scroll arriba
                        $("#divGuestsTable").animate({ scrollTop: 0 }, 300);

                        if(allEventGuest.length == 0) {
                            //los pedimos al servidor
                            Restangular.all('EventsSpaceGuests').getList(options).then(function (results) {
                                allEventGuest = results;
                                let localFilteredResults = getFiteredGuests();

                                //devolvemos solo la pagina
                                localFilteredResults = localFilteredResults.slice(_page * _pageSize, (_page + 1) * _pageSize);
                                $scope.totalRows = allEventGuest.length;
                                localFilteredResults["totalRows"] = $scope.totalRows;

                                deferred.resolve(localFilteredResults);
                            });
                        }else{
                            //trabajmos en los cargados localmente
                            var localFilteredResults = getFiteredGuests();

                            //devolvemos solo la pagina
                            localFilteredResults = localFilteredResults.slice(_page * _pageSize, (_page + 1) * _pageSize);
                            localFilteredResults["totalRows"] = $scope.totalRows;

                            deferred.resolve(localFilteredResults);
                        }
                        
                        return deferred.promise;
                    }
                };
            }

        }
        
        $scope.getPrincipalName = function (guest) {
            let principalName = '';
            let principalGuest = allEventGuest.find(m=>m.person_id == guest.referrer_person_id);
            if(principalGuest != null){
                principalName = principalGuest.FK_events_guests_persons.surname;
                if(principalGuest.FK_events_guests_persons.lastname) principalName += " " + principalGuest.FK_events_guests_persons.lastname;
                principalName += ", " + principalGuest.FK_events_guests_persons.name;
            }
            return principalName;
        };

        $scope.getConfirmationStatusReferred = function (guest) {
            let status = '';
            let principalGuest = allEventGuest.find(m => m.person_id == guest.referrer_person_id);
            if (principalGuest != null) {
                status = principalGuest.confirmation_status;
            }
            return status;
        };


        $scope.configDialog = function (item) {
            let $modalInstance = null;
            if ($rootScope.sizeLg) {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: ConfigGuestModalView,
                    size: "lg",
                    controller: "ConfigGuestsModalCtrl",
                    resolve: {
                        item: function () {
                            return item;
                        },
                        event: function () {
                            return $scope.event;
                        }
                    }
                });
            } else {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: ConfigGuestModalView,
                    controller: "ConfigGuestsModalCtrl",
                    resolve: {
                        item: function () {
                            return item;
                        },
                        event: function () {
                            return $scope.event;
                        }
                    }
                });
            }

            //Response del modal
            $modalInstance.result.then(function (data) {
                $scope.loadGuest();
                if (!$scope.$$phase) $scope.$apply();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
            
        }

        //Funcion que se al seleccionar algo en el grid.
        let callbackFunctionRowSelected = function (row, evt) {
            let addAll = row.length > 1;
            if (!addAll) {

                //if (row.length == 1) row = row[0];//a veces llega como un array otras como un objeto. No funciona si se pone la linea porque entonces no se puede seleccionar solo a uno.
                if (typeof row.entity != "undefined") {
                let nameToShow = getFullSeatName(row.entity);
                let prefered = 99999999;
                    if (row.entity.FK_events_guests_persons_positions && row.entity.FK_events_guests_persons_positions.FK_persons_positions_positions != null) {
                    prefered = row.entity.FK_events_guests_persons_positions.position_order != null ? row.entity.FK_events_guests_persons_positions.position_order : row.entity.FK_events_guests_persons_positions.FK_persons_positions_positions.position_order;
                }
                    const newRow = {id: row.entity.id, name: nameToShow, color: row.entity.color, prefered: prefered};
                    const index = $scope.selectedRows.map(function (e) {
                        return e.id;
                    }).indexOf(newRow.id);
                    if (row.isSelected) {
                        if (index < 0) $scope.selectedRows.push(newRow);
                } else {
                    if (index > -1) $scope.selectedRows.splice(index, 1);
                    }
                    }
            } else {
                if (row[0].isSelected) {
                    //se ha seleccionado todo.
                    let options: any = {};
                    options.event_id = $stateParams.id;
                    options.name_surnames = $scope.search.name_surnames;
                    options._sortBy = $scope.search._sortBy;
                    options.allocated = ($scope.search.not_allocated == true ? false : null);
                    if($scope.search.allocated == true) {
                        options.allocated = true;
                    }
                    options.groups_ids = $scope.search.groups;
                    options.positions_ids = $scope.search.positions;
                    options.event_space_id = id;
                    if ($scope.isDashboard) options.allocated = true;
                    options.position_name = $scope.search.position_name;//falta
                    options.confirmed = $scope.search.confirmed;//falta

                    //Tenemos que recorrer lo diseñado para actualizar los datos del grid correctamente.    
                    Restangular.all('EventsSpaceGuests').getList(options).then(function (results) {
                        $scope.selectedRows = [];
                        angular.forEach(results, function (rowResult) {
                            let nameToShow = getFullSeatName(rowResult);
                            $scope.selectedRows.push({ id: rowResult.id, name: nameToShow, color: rowResult.color });
                        });
                    });
                } else {
                    $scope.selectedRows = [];
                }
               
            }
        }

        let callbackFunctionItemChange = function () {

            $timeout(function () { $scope.$emit('guests-loaded'); }, 250);//lo pongo así porque sino falla la primera vez

        }

        //Se lanza una vez cargados los invitados.
                $scope.$on("guests-loaded", function () {


                    for (const row of allEventGuest) {
                //const row = allEventGuest[i];
                            for (const zone of $scope.space.items) {
                                // const zone = $scope.space.items[aux];
                                if (zone.type == "group" && typeof zone.guests != "undefined") {
                                    for (const guest of zone.guests) {
                                        //const guest = zone.guests[k];
                                        if (guest.event_guest_id == row.id) {
                                            for (const obj of zone._objects) {
                                               // const obj = zone._objects[j];

                                                /*if (obj.options != null && obj.options.zone_file == guest.file && obj.options.zone_position == guest.position && obj.options.zone_prefered == guest.prefered) {

                                                    row.zone = obj.options.zone;
                                                    row.zone_type = obj.options.zone_type;
                                                    row.zone_file = obj.options.zone_file;
                                                    row.zone_position = obj.options.zone_position;
                                                    row.zone_prefered = obj.options.zone_prefered;
                                                    row.locked = obj.options.locked;
                                                    row.droppable = obj.options.droppable;
                                                    if (!$scope.$$phase) $scope.$apply();
                                                    logService.debug("Entra: ", obj.options.zone_file, obj.options.zone_position, obj.options.zone_prefered);
                                                    break;
                                                }*/
                                            }
                                        }
                                    }
                                }
                            };

                            for (const selected of $scope.selectedRows) {
                                   // let selected = $scope.selectedRows[select];
                                    if (row.id == selected.id) {
                                        $scope.gridEventSpaceGuest.gridApi.selection.toggleRowSelection(row);
                                        break;
                                    }
                            };
                    };

        });

        $scope.loadGuest = function () {

            $scope.gridEventSpaceGuest.gridApi.core.raise.itemChanged($scope);
            //$timeout(function () { $scope.$broadcast("guests-loaded"); }, 500);//Esta puesto gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);

        }

        $scope.clearList = function () {
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('general.delete_message') + " " + $filter('translate')('events_guests_zones.clear_guests_message') + "?",
                onAccept: function () {
                    Restangular.all('EventsSpaceGuests/ClearGuests').getList({ event_space_id: $scope.spaceDTO.id }).then(function (results) {
                        toastr.success($filter('translate')('events_guests_zones.delete_success'));
                        $uibModalInstance.close($scope.val);
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });
        }
        $scope.clearListPlaces = function () {
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('general.delete_message') + " " + $filter('translate')('events_guests_zones.clear_places_message') + "?",
                onAccept: function () {
                    Restangular.all('EventsSpaceGuests/ClearGuestsPlaces').getList({ event_space_id: $scope.spaceDTO.id }).then(function (results) {
                        toastr.success($filter('translate')('events_guests_zones.delete_success'));
                        $uibModalInstance.close($scope.val);
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });
        }

        $scope.changeOrder = function (order) {
            $scope.search._sortBy = order;
        };

        $scope.filterGroups = function () {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: SearchGroupModalView,
                size: "lg",
                controller: "SearchGroupModalCtrl",
                resolve: {
                    preselect: function () {
                        return true;
                    },
                    event_id: function () {
                        return $stateParams.id;
                    },
                    is_filter: function () {
                        return true;
                    },
                    listGroupsIds: function () {
                        return $scope.search.groups;
                    },
                    listPositionsIds: function () {
                        return $scope.search.positions;
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (groups) {
                $scope.search.hasFilteredGroups = groups.ids.length > 0;
                $scope.search.groups_names = groups.ids.length + " " + $filter('translate')('guest.groups') + ". " + groups.listPositions.length + " " + $filter('translate')('guest.position');
                /*$scope.search.groups_names = _.chain(groups.groups)
                    .filter(function (group) { return _.some(groups.ids, function (id) { return id == group.id; }); })
                    .reduce(function (memo, group) { return memo + group.name + "\n"; }, "")
                    .value();*/
                $scope.search.groups = groups.ids;
                $scope.search.positions = groups.listPositions;

            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        };

        $scope.unfilterGroups = function () {
            $scope.search.groups = [];
            $scope.search.positions = [];
            $scope.search.hasFilteredGroups = false;
        }
        
        function assignPositions(firstPlace, placeIncrement) {
            //asignar posiciones
            angular.forEach(guestsInfo.sort(function (a, b) { return parseInt(a.prefered) < parseInt(b.prefered) ? -1: 1 }), function (guest) {
                findPosition(guest.id, guest.name, firstPlace, guest.color, placeIncrement);
                firstPlace += placeIncrement;
            });

            //renderizar
            $scope.canvas.renderAll();
        }
        
        let checkBusyPlacesAndAssign = function(firstPositionNumber, firstPositionIncrementation) {
            let added = true;
            let busyPlaces = SpacesService.arePlacesFree(firstPositionNumber, firstPositionIncrementation, guestsInfo.length, $scope.space.items);
            let options = {
                busyPlaces: busyPlaces.toString()
            }
            if (busyPlaces.length > 0) {
                let $modalInstanceAction = $uibModal.open({
                    animation: true,
                    template: PlaceNotAvailableActionModalView,
                    size: "lg",
                    scope: $scope,
                    resolve: {
                        options: function(){ return options; }
                    },
                    controller: ['$uibModalInstance', 'options', function ($uibModalInstance, options) {
                        $scope.options = options;

                        $scope.moveGuests = function () {
                            $uibModalInstance.close('move');
                        };
                        $scope.replaceGuests = function () {
                            $uibModalInstance.close('replace');
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                            added = false;
                        };
                    }]
                });
                //Response del modal
                $modalInstanceAction.result.then(function(result) {
                    if(result === "move") {
                        assignPositions(firstPositionNumber, firstPositionIncrementation);
                    }
                });
            } else {
                assignPositions(firstPositionNumber, firstPositionIncrementation);
            }
            return added;
        }

        $scope.updateSelectedRows = function(){
            $scope.selectedRows = [];
            $scope.gridEventSpaceGuest.gridApi.selection.getSelectedRows().forEach(m => {
                console.log(m);
                let selectedRow = {
                    id: m.id,
                    name: m.FK_events_guests_persons.fullnameNormalized + (m.FK_events_guests_persons_positions && m.FK_events_guests_persons_positions.FK_persons_positions_positions ? '\n' + m.FK_events_guests_persons_positions.FK_persons_positions_positions.name : ''),
                    color: m.color,
                    prefered: m.prefered
                };
                $scope.selectedRows.push(selectedRow);
            });
            return $scope.selectedRows;
        }

        $scope.setPositions = function () {

            let loadData = function () {
                if (guestsInfo.length > 0) {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: SetFirstPositionModalView,
                        size: "sm",
                        scope: $scope,
                        controller: ['$uibModalInstance', function ($uibModalInstance) {

                            $scope.val = { firstPositionNumber: 1, firstPositionIncrementation: 1 };
                            $scope.ok = function () {
                                $uibModalInstance.close($scope.val);
                            };
                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                        }]
                    });
                    //Response del modal
                    $modalInstance.result.then(function (result) {
                        let firstPositionNumber = result.firstPositionNumber;
                        let firstPositionIncrementation = result.firstPositionIncrementation;


                        checkBusyPlacesAndAssign(firstPositionNumber, firstPositionIncrementation);

                    }, function () {
                        console.info('Modal dismissed at: ' + new Date());
                        if (!$scope.$$phase) $scope.$apply();
                    });

                } else {

                    modalService.message({
                        title: $filter('translate')('events.spaces.select_guests_title_error'),
                        message: $filter('translate')('events.spaces.select_guests_message_error'),
                        onAccept: function () { }
                    });
                }
            };

            //console.log($scope.selectedRows);
            $scope.updateSelectedRows();
            //console.log($scope.selectedRows);
            guestsInfo = $scope.selectedRows;
            loadData();

            //quitamos la seleccion
            $scope.gridEventSpaceGuest.gridApi.selection.clearSelectedRows();
            $scope.selectedRows = [];
        };

        $scope.setZone = function () {

            let loadData = async function () {
                if (guestsInfo.length > 0) {
                    $scope.eventSpaceZones = await eventService.getSpaceZones($stateParams.id, id);
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: SetZoneModalView,
                        size: "sm",
                        scope: $scope,
                        controller: ['$uibModalInstance', function ($uibModalInstance) {
                            $scope.setZoneModalData = { event_space_zone: null };
                            $scope.ok = function () {
                                $uibModalInstance.close($scope.setZoneModalData);
                            };
                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                        }]
                    });
                    $modalInstance.result.then(function (result) {
                        //asignamos la zona a los invitados seleccionados
                        angular.forEach(guestsInfo, function (guest) {
                            //añadir invitado a object e zone
                            let zone = result.event_space_zone;
                            let row = allEventGuest.find(r => r.id === guest.id);
                            row.zone = zone.name;
                            row.zone_type = zone.type;
                            row.zone_file = null;
                            row.zone_position = null;
                            row.zone_prefered = null;
                            row.locked = false;

                            //buscamos la zona del canvas
                            let canvasZone = $scope.space.items.find(m => m.guid === zone.code);
                            $scope.addGuestToObject(canvasZone, null, null, null, false, guest.id, guest.FK_events_guests_persons?.fullnameNormalized, guest.color, 0);
                        });
                        if (!$scope.$$phase) $scope.$apply();
                    }, function () {
                        console.info('Modal dismissed at: ' + new Date());
                        if (!$scope.$$phase) $scope.$apply();
                    });

                } else {
                    modalService.message({
                        title: $filter('translate')('events.spaces.select_guests_title_error'),
                        message: $filter('translate')('events.spaces.select_guests_message_error'),
                        onAccept: function () { }
                    });
                }
            };
            
            $scope.updateSelectedRows();
            guestsInfo = $scope.selectedRows;
            loadData();

            //quitamos la seleccion
            $scope.gridEventSpaceGuest.gridApi.selection.clearSelectedRows();
            $scope.selectedRows = [];
        };

        $scope.clean = function () {
            $scope.search = {
                name_surnames: "",
                not_allocated: null,
                groups: null,
                _sortBy: "prefered",
                position_name: "",
                confirmed: false,
                allocated: null
            };
            $scope.loadGuest();
        }

        $scope.describeZone = function (entity) {
            let ret = "";
            if (entity.zone_file !== "" && entity.zone_file != null || entity.zone_position != null) {
                if (entity.zone_type === "table") {
                    ret += "Asiento " + entity.zone_position;
                } else if (entity.zone_type === "zone") {
                    ret += "Fila " + entity.zone_file + " - Asiento " + entity.zone_position;
                } else if (entity.zone_type === "vehicle") {
                    ret += "Fila " + entity.zone_file + " - Asiento " + entity.zone_position;
                }
            } else {
                ret += "(Sin acomodar)";
            }
            return ret;
        };

        $scope.askForFreePlace = function(entity){
            let options = {
                move: false
            };
            let $modalInstanceAction = $uibModal.open({
                animation: true,
                template: FreePlaceActionModalView,
                size: "md",
                scope: $scope,
                resolve: {
                    options: function(){ return options; }
                },
                controller: ['$uibModalInstance', 'options', function ($uibModalInstance, options) {
                    $scope.freePlaceModalOptions = options;
                    $scope.freePlaceModalOk = function () {
                        $uibModalInstance.close($scope.freePlaceModalOptions.move);
                    };
                    $scope.freePlaceModalCancel = function () {
                        $uibModalInstance.dismiss('cancel');
                        let added = false;
                    };
                }]
            });
            //Response del modal
            $modalInstanceAction.result.then(function(move) {
                $scope.freePlace(entity, move);
            });
        }

        let moveGuest = function (entity, currentPosition, newPosition) {
            logService.debug("moveGuest", entity, currentPosition, newPosition);
            let zones = $scope.space.items.filter(m=>m.type=="group" && m.options!=null);


            //limpiamos posicion actual
            $scope.freePlace(entity, false);
            /*for( let i = 0 ; i < zones.length ; i++){
                let zone = zones[i];
                let currentPlace = zone._objects.find(m=>m.options?.zone_prefered==currentPosition);
                if(currentPlace != null){
                    logService.debug("moveGuest -> currentPosition", currentPlace);
                    break;
                }
            }*/

            //buscamos posicion nueva y la asignamos
            for(let i = 0 ; i < zones.length ; i++){
                let zone = zones[i];
                let newPlace = zone._objects.find(m=>m.options?.zone_prefered==newPosition);
                if(newPlace != null){
                    logService.debug("moveGuest -> newPosition", newPlace);

                    //asignamos posicion nueva
                    let fullPlaceText = getFullSeatName(entity);
                    $scope.addGuestToObject(zone, 
                        newPlace.options.zone_file, 
                        newPlace.options.zone_position, 
                        newPlace.options.zone_prefered, 
                        newPlace.options.locked,
                        entity.id, //guestId, 
                        fullPlaceText, //guestName, 
                        entity.color, //guestColor, 
                        1 //positionIncrementation
                    );

                    //asignamos nuevos datos de posicion
                    entity.zone = newPlace.options.zone;
                    entity.zone_type = newPlace.options.zone_type;
                    entity.zone_file = newPlace.options.zone_file;
                    entity.zone_position = newPlace.options.zone_position;
                    entity.zone_prefered = newPlace.options.zone_prefered;
                    entity.locked = newPlace.options.locked;

                    break;
                }
            }

        }

        $scope.freePlace = function (entity, move) {
            let deletePrefered = 0;
            let previousGuest = null;
            let guestsToMove = [];
            let previousPrefered = 0;
            
            //buscamos si plazas para quitarlo
            for (let j = 0; j < $scope.canvas._objects.length; j++) {
                const zone = $scope.canvas._objects[j];
                const finalGuests = new Array();
                if (typeof zone.guests != "undefined") {
                    let guests = zone.guests.sort(function (a, b) { return parseInt(a.prefered) < parseInt(b.prefered) ? -1 : 1;});
                    for (let i = 0; i < guests.length; i++) {
                        const guest = guests[i];
                        if (guest.event_guest_id != entity.id) {
                            finalGuests.push(guest);
                        } else {
                            deletePrefered = parseInt(guest.prefered);
                            previousGuest = guest;
                            previousPrefered = parseInt(guest.prefered);
                            //marcamos plaza como libre
                            for (let p = 0; p < zone._objects.length; p++) {
                                const place = zone._objects[p];
                                if (typeof place.options != "undefined") {
                                    if (place.options.zone_file == guest.file && place.options.zone_position == guest.position) {
                                        place.fill = $scope.place_color_free;
                                        //Eliminamos el texto
                                        zone.forEachObject(function (objFind) {
                                            //Buscamos el texto por ID para eliminarlo y poner el nuevo.
                                            //hacemos que no borre si no tiene id, porque se estaba cargando todos los sitios
                                            if (objFind.options && objFind.options.id == place.options.zone_prefered && typeof objFind.options.id!="undefined") {
                                                zone.set('active', true);
                                                zone.remove(objFind);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
                zone.guests = finalGuests;
            }

            //si hay que mover siguientes plazas, reasignamos posiciones hasta el siguiente hueco
            if(move){
                guestsInfo = [];
                //buscamos plazas contiguas
                let nextPosition = parseInt(entity.zone_prefered) + 1;
                while(true){
                    //busacmos si hay invitado en la plaza
                    //let nextGuest = $scope.gridEventSpaceGuest.data.find(m=>m.zone_prefered==nextPosition);
                    let nextGuest = allEventGuest.find(m=>m.zone_prefered==nextPosition);
                    logService.debug(nextPosition, nextGuest);
                    if(nextGuest!=null){
                        guestsInfo.push(nextGuest);
                    }else{
                        break;
                    }
                    if(nextPosition>5000) break;
                    nextPosition++;
                }
                angular.forEach(guestsInfo.sort(function (a, b) { return parseInt(a.prefered) < parseInt(b.prefered) ? -1: 1 }), function (guest) {
                    //lo echamos una laza para atras
                    moveGuest(guest, guest.zone_prefered, guest.zone_prefered-1);
                });
                //assignPositions(entity.zone_prefered, -1);
                guestsInfo = [];
            }

            //limpiamos datos de zona
            entity.zone = "";
            entity.zone_type = "";
            entity.zone_file = "";
            entity.zone_position = "";
            entity.zone_prefered = "";
            entity.locked = false;
            
            //renderizar
            $scope.canvas.renderAll();
            if (!$scope.$$phase) $scope.$apply();
        };

        $scope.draggedObject = null;

        (window as any).allowDrop = function (event) {
            event.preventDefault();
        };


        (window as any).drag = function (ev) {
            ev.dataTransfer.setData("text", ev.target.id);
        };


        (window as any).dragEnd = function (event) {
            $scope.draggedObject = event.target;
            $scope.overTarget = null;
        };

        
        $scope.onObjectDblClick = function (target) {
            if (target.localType === "zone") {
                $scope.createZone(target, target.options.left, target.options.top);
            } else if (target.localType === "table") {
                $scope.createTable(target, target.options.left, target.options.top);
            } else if (target.localType === "vehicle") {
                $scope.createVehicle(target, target.options.left, target.options.top);
            }
        };
        
        function getFullSeatName(row) {
            let name = "";
            if(row != undefined) {
                if($scope.spaceDTO.useFullname) {
                    name = row.FK_events_guests_persons.fullnameNormalized;
                }
                if($scope.spaceDTO.usePosition) {
                    if (row.FK_events_guests_persons_positions != undefined && row.FK_events_guests_persons_positions.FK_persons_positions_positions != undefined) {

                        let position = "";
                        let posObj = row.FK_events_guests_persons_positions.FK_persons_positions_positions;

                        if (posObj.FK_positions_tl_positions.length > 0) {
                            let translation = posObj.FK_positions_tl_positions[0];
                            if (row.FK_events_guests_persons.gender == 'F') {
                                position = translation.female_short_description != null ? translation.female_short_description : translation.female_description;
                            } else if (row.FK_events_guests_persons.gender == 'M') {
                                position = translation.male_short_description != null ? translation.male_short_description : translation.male_description;
                            } else{
                                position = translation.name;
                            }
                            if (position == "" || position == null) {
                                position = translation.name;
                            }
                        }
                        if($scope.spaceDTO.useFullname) {
                            name += "\n";
                        }
                        name += position;
                    }
                }
            }
            return name;          
        }

        $scope.onMouseOver = function (e) {
            //buscamos objeto dentro del grupo
            if ($scope.draggedObject == null) return;

            //falta ver como traladar posicion a rotacion

            const zoneObj = e.target;
            let positionObj = null;
            if (e.target.type === "group") {
                const group = e.target;
                const x = e.e.offsetX - group.left - (group.width / 2);
                const y = e.e.offsetY - group.top - (group.height / 2);
                for (var i = 0; i < e.target._objects.length; i++) {
                    const obj = e.target._objects[i];
                    if (obj.options != null && obj.options.droppable) {
                        if (x >= obj.left && x <= (obj.left + obj.width) && y >= obj.top && y <= (obj.top + obj.height)) {
                            positionObj = obj;
                            break;
                        }
                    }
                }
            }

            if (positionObj == null || (positionObj != null && !positionObj.options != null && !positionObj.options.droppable)) return;

            for (const row of allEventGuest) {
                if (row.id == $($scope.draggedObject).attr("row-id")) {
                    const nameToShow = getFullSeatName(row);

                    $scope.addGuestToObject(zoneObj, positionObj.options.zone_file, positionObj.options.zone_position, positionObj.options.zone_prefered, positionObj.options.locked, row.id, nameToShow, row.color, 1);

                    //registrar info de zon
                    row.zone = positionObj.options.zone;
                    row.zone_type = positionObj.options.zone_type;
                    row.zone_file = positionObj.options.zone_file;
                    row.zone_position = positionObj.options.zone_position;
                    row.zone_prefered = positionObj.options.zone_prefered;
                    row.locked = positionObj.options.locked;

                    if (!$scope.$$phase) $scope.$apply();
                    break;
                }
            }
            $scope.draggedObject = null;
        };

        $scope.isDown = false;
        $scope.startPosition = { x: 0, y: 0 };
        $scope.polygonMode = true;
        $scope.activeShape = false;
        $scope.activeLine = undefined;
        $scope.pointArray = [];
        $scope.lineArray = [];
        $scope.spaceImages = null;
        $scope.showImageSelector = false;
        
        $scope.drawLine = function() {
            if(!$scope.canvas.isDrawingMode) return;
            $scope.removeEvents();
            $scope.canvas.on('mouse:down', function(o) {
                $scope.isDown = true;
                let pointer = $scope.canvas.getPointer(o.e);
                let points = [pointer.x, pointer.y, pointer.x, pointer.y];
                $scope.line = new fabric.Line(points, {
                    localType: 'line',
                    guid: $scope.guid(),
                    strokeWidth: 3,
                    fill: $scope.fillColor,
                    stroke: $scope.strokeColor,
                    originX: 'center',
                    originY: 'center'
                });
                $scope.canvas.add($scope.line);
            });
            $scope.canvas.on('mouse:move', function(o) {
                if (!$scope.isDown) return;
                let pointer = $scope.canvas.getPointer(o.e);
                $scope.line.set({
                    x2: pointer.x,
                    y2: pointer.y
                });
                $scope.canvas.renderAll();
            });
            $scope.canvas.on('mouse:up', function(o) {
                $scope.isDown = false;
                $scope.space.items.push($scope.line);
            });            
        }
        
        $scope.drawRectangle = function(transparent) {
            if(!$scope.canvas.isDrawingMode) return;
            $scope.removeEvents();

            $scope.canvas.on('mouse:down', function(o) {
                $scope.isDown = true;
                let pointer = $scope.canvas.getPointer(o.e);
                $scope.startPosition = { x: pointer.x, y: pointer.y};
                $scope.rect = new fabric.Rect({
                    localType: 'rectangle',
                    guid: $scope.guid(),
                    left: $scope.startPosition.x,
                    top: $scope.startPosition.y,
                    originX: 'left',
                    originY: 'top',
                    width: pointer.x - $scope.startPosition.x,
                    height: pointer.y - $scope.startPosition.y,
                    angle: 0,
                    fill: transparent?'rgba(0,0,0,0)':$scope.fillColor,
                    stroke: $scope.strokeColor,
                    strokeWidth: 3,
                    transparentCorners: false
                });
                $scope.canvas.add($scope.rect);
            });
            
            $scope.canvas.on('mouse:move', function(o) {
                if (!$scope.isDown) return;
                let pointer = $scope.canvas.getPointer(o.e);

                if ($scope.startPosition.x > pointer.x) {
                    $scope.rect.set({
                        left: Math.abs(pointer.x)
                    });
                }
                if ($scope.startPosition.y > pointer.y) {
                    $scope.rect.set({
                        top: Math.abs(pointer.y)
                    });
                }

                $scope.rect.set({
                    width: Math.abs($scope.startPosition.x - pointer.x),
                    height: Math.abs($scope.startPosition.y - pointer.y)
                });

                $scope.canvas.renderAll();
            });

            $scope.canvas.on('mouse:up', function(o) {
                $scope.isDown = false;
                $scope.rect.set({
                   originX: 'center',
                   originY: 'center', 
                   left: $scope.rect.left + $scope.rect.width / 2,
                   top: $scope.rect.top + $scope.rect.height / 2
                });
                $scope.space.items.push($scope.rect);
            });        
        }

        $scope.drawCircle = function (transparent) {
            if(!$scope.canvas.isDrawingMode) return;
            $scope.removeEvents();
            $scope.canvas.on('mouse:down', function(o) {
                $scope.isDown = true;
                let pointer = $scope.canvas.getPointer(o.e);
                $scope.startPosition = { x: pointer.x, y: pointer.y};
                $scope.circle = new fabric.Circle({
                    localType: 'circle',
                    guid: $scope.guid(),
                    left: pointer.x,
                    top: pointer.y,
                    radius: 1,
                    strokeWidth: 3,
                    stroke: $scope.strokeColor,
                    fill: transparent?'rgba(0,0,0,0)':$scope.fillColor,
                    originX: 'center',
                    originY: 'center'
                });
                $scope.canvas.add($scope.circle);
            });

            $scope.canvas.on('mouse:move', function(o) {
                if (!$scope.isDown) return;
                let pointer = $scope.canvas.getPointer(o.e);
                $scope.circle.set({
                    radius: Math.abs($scope.startPosition.x - pointer.x)
                });
                $scope.canvas.renderAll();
            });

            $scope.canvas.on('mouse:up', function(o) {
                $scope.space.items.push($scope.circle);
                $scope.isDown = false;
            });
        }

        $scope.drawPolygon = function (transparent) {
            if(!$scope.canvas.isDrawingMode) return;
            $scope.removeEvents();
            $scope.canvas.on('mouse:down', function(o) {
                $scope.polygonMode = true;
                if(o.target && o.target.id === $scope.pointArray[0].id){
                    $scope.generatePolygon(transparent);
                }
                if($scope.polygonMode){
                    $scope.addPointToPolygon(o);
                }                
            });

            $scope.canvas.on('mouse:up', function (options) {

            });
            
            $scope.canvas.on('mouse:move', function (options) {
                if($scope.activeLine && $scope.activeLine.class === "line"){
                    let pointer = $scope.canvas.getPointer(options.e);
                    $scope.activeLine.set({ x2: pointer.x, y2: pointer.y });

                    let points = $scope.activeShape.get("points");
                    $scope.pointArray[$scope.pointArray.length] = {
                        x:pointer.x,
                        y:pointer.y
                    }
                    $scope.activeShape.set({
                        points: points
                    });
                    $scope.canvas.renderAll();
                }
                $scope.canvas.renderAll();
            });
        }

        $scope.addPointToPolygon = function(options) {
            const crypto = window.crypto || (window as any).msCrypto;
            let array = new Uint32Array(1);
            let random = crypto.getRandomValues(array); // Compliant for security-sensitive use cases

            let id = new Date().getTime() + random[0];
            let circle = new fabric.Circle({
                radius: 5,
                fill: '#ffffff',
                stroke: '#333333',
                strokeWidth: 0.5,
                left: (options.e.layerX/$scope.canvas.getZoom()),
                top: (options.e.layerY/$scope.canvas.getZoom()),
                selectable: false,
                hasBorders: false,
                hasControls: false,
                originX:'center',
                originY:'center',
                id:id
            });
            if($scope.pointArray.length === 0){
                circle.set({
                    fill:'red'
                })
            }
            let points = [(options.e.layerX/$scope.canvas.getZoom()),(options.e.layerY/$scope.canvas.getZoom()),(options.e.layerX/$scope.canvas.getZoom()),(options.e.layerY/$scope.canvas.getZoom())];
            let line = new fabric.Line(points, {
                strokeWidth: 2,
                fill: '#999999',
                stroke: '#999999',
                class:'line',
                originX:'center',
                originY:'center',
                selectable: false,
                hasBorders: false,
                hasControls: false,
                evented: false
            });
            if($scope.activeShape){
                let pos = $scope.canvas.getPointer(options.e);
                let points = $scope.activeShape.get("points");
                points.push({
                    x: pos.x,
                    y: pos.y
                });
                let polygon = new fabric.Polygon(points,{
                    stroke:'#333333',
                    strokeWidth:1,
                    fill: '#cccccc',
                    opacity: 0.1,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    evented: false
                });
                $scope.canvas.remove($scope.activeShape);
                $scope.canvas.add(polygon);
                $scope.activeShape = polygon;
                $scope.canvas.renderAll();
            }
            else{
                let polyPoint = [{x:(options.e.layerX/$scope.canvas.getZoom()),y:(options.e.layerY/$scope.canvas.getZoom())}];
                let polygon = new fabric.Polygon(polyPoint,{
                    stroke:'#333333',
                    strokeWidth:1,
                    fill: '#cccccc',
                    opacity: 0.1,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    evented: false
                });
                $scope.activeShape = polygon;
                $scope.canvas.add(polygon);
            }
            $scope.activeLine = line;

            $scope.pointArray.push(circle);
            $scope.lineArray.push(line);
            
            $scope.canvas.add(line);
            $scope.canvas.add(circle);
            $scope.canvas.selection = false;
        }
        
        $scope.generatePolygon = function(transparent){
            let points = [];
            $.each($scope.pointArray,function(index, point){
                if(point.left !== undefined) {
                    points.push({
                        x: point.left,
                        y: point.top
                    });
                }
                $scope.canvas.remove(point);
            });
            $.each($scope.lineArray,function(index, line){
                $scope.canvas.remove(line);
            });
            $scope.canvas.remove($scope.activeShape);
            $scope.canvas.remove($scope.activeLine);
            let polygon = new fabric.Polygon(points,{
                localType: 'polygon',
                guid: $scope.guid(),
                stroke:'#333333',
                strokeWidth:2,
                fill: transparent?'rgba(0,0,0,0)':$scope.fillColor,
                opacity: 1,
                hasBorders: false,
                hasControls: false
            });
            $scope.canvas.add(polygon);

            $scope.activeLine = null;
            $scope.activeShape = null;
            $scope.polygonMode = false;
            $scope.pointArray = [];
            $scope.lineArray = [];
            $scope.canvas.selection = true;
        }

        $scope.drawText = function() {
            if($scope.canvas.isDrawingMode) return;
            $scope.removeEvents();
            $scope.canvas.on('mouse:down', function(o) {
                $scope.isDown = true;
                let pointer = $scope.canvas.getPointer(o.e);
                $scope.text = new fabric.IText('Texto', {
                    localType: 'text',
                    guid: $scope.guid(),
                    left: pointer.x,
                    top: pointer.y,
                    stroke: $scope.strokeColor,
                    fill: $scope.fillColor,
                    originX: 'center',
                    originY: 'center'
                });
                $scope.canvas.add($scope.text);
            });

            $scope.canvas.on('mouse:up', function(o) {
                $scope.isDown = false;
                $scope.space.items.push($scope.text);
                $scope.selectTool('selector');
            });
        }
        
        $scope.selectImage = function(uid) {
            $scope.selectedImage = uid;
        }

        $scope.drawImage = function() {
            if($scope.canvas.isDrawingMode) return;
            $scope.showImageSelector = true;
            if($scope.spaceImages == null) {
                Restangular.all('Files/spaceAssets').getList().then(function (spaceFiles) {
                    $scope.spaceImages = [];
                    spaceFiles.forEach(function(file) {
                        $scope.spaceImages[$scope.spaceImages.length] = {
                            uid: file.uid,
                            url: (window as any).CONFIG.api_url + 'files/' + file.uid + '/download'
                        };
                    });
                });
            }
            $scope.removeEvents();
            $scope.canvas.on('mouse:down', function(o) {
                $scope.isDown = true;
                let pointer = $scope.canvas.getPointer(o.e);

//                $scope.createImage(null, 'plant-01', pointer.x, pointer.y);
                $scope.createImage(null, $scope.selectedImage, pointer.x, pointer.y);

            });

            $scope.canvas.on('mouse:up', function(o) {
                $scope.isDown = false;
                $scope.showImageSelector = false;
                $scope.selectTool('selector');
            });
        }


        $scope.removeEvents = function () {
            $scope.canvas.off('mouse:down');
            $scope.canvas.off('mouse:move');
            $scope.canvas.off('mouse:up');

            $scope.canvas.on('mouse:down', function(opt) {
                let evt = opt.e;
                if (evt.altKey === true) {
                    this.isDragging = true;
                    this.selection = false;
                    this.lastPosX = evt.clientX;
                    this.lastPosY = evt.clientY;
                }
            });

            $scope.canvas.on('mouse:move', function(opt) {
                if (this.isDragging) {
                    const e = opt.e;
                    const vpt = this.viewportTransform;
                    vpt[4] += e.clientX - this.lastPosX;
                    vpt[5] += e.clientY - this.lastPosY;
                    this.requestRenderAll();
                    this.lastPosX = e.clientX;
                    this.lastPosY = e.clientY;
                }
            });
            $scope.canvas.on('mouse:up', function(opt) {
                // on mouse up we want to recalculate new interaction
                // for all objects, so we call setViewportTransform
                this.setViewportTransform(this.viewportTransform);
                this.isDragging = false;
                this.selection = true;
            });

        }

        $scope.getPositionGuest = function (positionNumber) {
            for (let aux = 0; aux < $scope.space.items.length; aux++) {
                const zone = $scope.space.items[aux];
                if (zone.type == "group") {
                    for (let j = 0; j < zone._objects.length; j++) {
                        if (typeof zone.guests == "undefined") zone.guests = new Array();
                        for (let z = 0; z < zone.guests.length; z++) {
                            if (zone.guests[z].prefered == positionNumber) {
                                return zone.guests[z];
                            }
                        }
                    }
                }
            }
            return null;
        };

        //Recorremos todos los espacios en busca de la posicion indicada
        function findPosition(guestId, guestName, positionNumber, guestColor, positionIncrementation) {
            logService.debug("findPosition -> START", guestId, guestName, positionNumber, guestColor, positionIncrementation);
            let foundObj = null;
            for (let aux = 0; aux < $scope.space.items.length; aux++) {
                const zone = $scope.space.items[aux];
                if (zone.type == "group" && zone.options != null) {
                    logService.debug("findPosition -> zone", zone.options?.name);
                    for (let j = 0; j < zone._objects.length; j++) {
                        const obj = zone._objects[j];
                        if (obj.options != null) {
                            logService.debug(" - findPosition -> check seat", zone.options?.name, obj.options.zone_prefered, obj.options);
                            if (obj.options.zone_prefered == positionNumber) {

                                foundObj = obj;

                                logService.debug(" - ****findPosition -> FOUND seat!", positionNumber, obj.options.zone_prefered, obj.options, obj);
                                if (typeof obj.options.locked === 'undefined') obj.options.locked = false;

                                //añadir invitado a object e zone
                                logService.debug("addGuestToObject");
                                $scope.addGuestToObject(zone, obj.options.zone_file, obj.options.zone_position, obj.options.zone_prefered, obj.options.locked, guestId, guestName, guestColor, positionIncrementation);
                                for (const row of allEventGuest) {
                                    if (row.id == guestId) {
                                        //registrar info de zon
                                        row.zone = obj.options.zone;
                                        row.zone_type = obj.options.zone_type;
                                        row.zone_file = obj.options.zone_file;
                                        row.zone_position = obj.options.zone_position;
                                        row.zone_prefered = obj.options.zone_prefered;
                                        row.locked = obj.options.locked;
                                        if (!$scope.$$phase) $scope.$apply();
                                    }
                                }
                                //salimos del bucle
                                break;
                            }
                        }
                    }
                    logService.debug("findPosition -> zone end!");
                    if(foundObj!=null) break;
                }
            }
            logService.debug("findPosition -> END", guestId, guestName, positionNumber, guestColor, positionIncrementation);
        }

        $scope.getAllSeatedGuests = function () {
            const seatedGuests = [];
            for (const zone of $scope.canvas._objects) {
                if (zone.guests) {
                    zone.guests.forEach(function (guest) {
                        seatedGuests.push(guest);
                    });
                }
            }
            return seatedGuests;
        }

        /* Buscamos si está en otra plaza para borralo, y una vez realizado esto, lo movemos a la indicada y empujamos
         * los que están debajo.
        */
        $scope.addGuestToObject = function (zone, file, position, prefered, locked, event_guest_id, name_guest, color_guest, positionIncrementation) {
            //logService.debug("addGuestToObject", zone, file, position, prefered, locked, event_guest_id, name_guest, color_guest, positionIncrementation);
            if (name_guest == null) name_guest = "";
            let preferedAux = prefered;
            if (typeof zone.guests == "undefined") {
                zone.guests = new Array();
            }

            //calculamos angulo de rotacion de la zona
            let angle = 0;
            if(zone.options?.positions_header=='up') angle = 180;

            //buscamos si esta en otra plazas para quitarlo
            for (let j = 0; j < $scope.canvas._objects.length; j++) {
                const zoneAux = $scope.canvas._objects[j];
                const finalGuests = new Array();
                if (typeof zoneAux.guests != "undefined") {
                    for (var i = 0; i < zoneAux.guests.length; i++) {
                        var guest = zoneAux.guests[i]; //para 

                        if (guest.event_guest_id != event_guest_id) {
                            finalGuests.push(guest);
                        } else {
                            //no entiendo porque solo se quita si ha cambiado su posicion o su fila
                            //se supopne que deberia quitarse siempre porque luego se añade siempre
                            //if (guest.file != file || guest.position != position) {
                                //marcamos plaza como libre
                                for (let p = 0; p < zoneAux._objects.length; p++) {
                                    var place = zoneAux._objects[p];
                                    if (typeof place.options != "undefined" && guest.file && guest.position) {
                                        if (place.options.zone_file == guest.file && place.options.zone_position == guest.position) {
                                            place.fill = $scope.place_color_free;
                                            zoneAux.forEachObject(function (objFind) {
                                                //Buscamos el texto por ID para eliminarlo y poner el nuevo.
                                                let preferedValue = place.options.zone_prefered + "";
                                                if (objFind.options && objFind.options.id === preferedValue) {
                                                    zoneAux.set('active', true);
                                                    zoneAux.remove(objFind);
                                                }
                                            });
                                        }
                                    }
                                }
                            /*} else {
                                console.log(`Keeping guest `, guest, zoneAux);
                                finalGuests.push(guest);
                            }*/
                        }
                    }
                }
                zoneAux.guests = finalGuests;
            }

            //marcamos plaza como ocupada
            for (var i = 0; i < zone._objects.length; i++) {
                var place = zone._objects[i];
                if (typeof place.options != "undefined") {
                    prefered = prefered + "";
                    if (place.options.zone_file == file && place.options.zone_position == position && place.options.zone_prefered == prefered) {
                        //buscamos si ya existe alguien en esa zona.
                        if (place.fill != $scope.place_color_free) {
                            angular.forEach(zone.guests, function (guest) {
                                if (guest.prefered == prefered) {
                                    //Ya hay alguien, borramos su nombre y lo movemos uno abajo.
                                    zone.forEachObject(function (objFind) {
                                        //Buscamos el texto por ID para eliminarlo y poner el nuevo.
                                        if (objFind.options && objFind.options.id === prefered) {
                                            zone.set('active', true);
                                            zone.remove(objFind);
                                        }
                                    });
                                    findPosition(guest.event_guest_id, guest.name_guest, parseInt(preferedAux) + parseInt(positionIncrementation), guest.color_guest, positionIncrementation);
                                }
                            });
                        }

                        if (color_guest == null) color_guest = $scope.place_color_occuped;

                        //añadimos guest a posicion
                        /*zone.guests.push({
                            event_guest_id: event_guest_id,
                            file: file,
                            position: position,
                            prefered: prefered + "",
                            locked: locked,
                            name_guest: name_guest,
                            color_guest: color_guest
                        });*/

                        //actualizamos space.items
                        /*let foundGuest = null;
                        for(const item of $scope.space.items) {
                            if(item.type=="group" && item.guests!=null){
                                for(let nGuest = 0; nGuest < item.guests.length; nGuest++){
                                    let guest = item.guests[nGuest];
                                    if(guest.event_guest_id == event_guest_id){
                                        guest.prefered = prefered + "";
                                        foundGuest = guest;
                                        break;
                                    }
                                }
                                if(foundGuest!=null) break;
                            }
                        }*/

                        //Marcamos el espacio como ocupado
                        place.fill = color_guest;
                        place.customSvgClass = "guestNameRect";
                        //place.setFill($scope.place_color_occuped);

                        //Añadimos el nombre de la persona
                        zone.add(new fabric.Textbox(name_guest, {
                            id: prefered,
                            left: place.left + (place.width/2),
                            top: place.top + (place.height/2),
                            width: place.width,
                            height: place.height,
                            fontSize: 7,
                            fontFamily: 'Arial',
                            textAlign: 'center',
                            breakWords: true,
                            lineHeight: 1,
                            originX: "center",
                            originY: "center",
                            options: { id: prefered },
                            customSvgClass: "guestName",
                            //fontWeight: 'bold',
                            angle: -angle,
                            fill: invertColor(color_guest)// para el color de contraste!!!!!!!!!
                        }));

                        //debug objetos zona
                        /*logService.debug(zone);
                        angular.forEach(zone._objects, function (obj) {
                            logService.debug(obj.type, obj.options?.id, obj);
                        });*/

                        
                    }
                }
            }

            //añadimos guest a posicion
            if(prefered=='null') prefered = null;
            zone.guests.push({
                event_guest_id: event_guest_id,
                file: file,
                position: position,
                prefered: prefered,
                locked: locked,
                name_guest: name_guest,
                color_guest: color_guest
            });

            //actualizamos space.items
            let foundGuest = null;
            for(const item of $scope.space.items) {
                if(item.type=="group" && item.guests!=null){
                    for(let nGuest = 0; nGuest < item.guests.length; nGuest++){
                        let guest = item.guests[nGuest];
                        if(guest.event_guest_id == event_guest_id){
                            guest.prefered = prefered!=null ? prefered + "" : null;
                            foundGuest = guest;
                            break;
                        }
                    }
                    if(foundGuest!=null) break;
                }
            }

            //renderizar
            $scope.canvas.renderAll();
            if (!$scope.$$phase) $scope.$apply();

        };

        $scope.sendToBack = function (target) {
            $scope.canvas.sendToBack(target);
        };

        $scope.deleteObject = function (target) {
            
            //borrar objeto
            $scope.space.items.splice($scope.space.items.indexOf(target), 1);
            $scope.drawSpace(false);
            //RECORREMOS A LOS INVITADOS PARA ACTUALIZAR SI ESTA PUESTO EN EL QUE SE HA BORRADO.
            
            if($scope.gridEventSpaceGuest !== undefined) {
                for (const row of allEventGuest) {
                    if (target.guests != null) {
                        for (let k = 0; k < target.guests.length; k++) {
                            const guest = target.guests[k];
                            if (guest.event_guest_id == row.id) {
                                row.zone = "";
                                row.zone_position = "";
                                row.zone_prefered = "";
                                if (!$scope.$$phase) $scope.$apply();
                                break;
                            }
                        }
                    }
                }
            }

//            $scope.loadGuest();
        };

        $scope.guid = function () {
            const crypto = window.crypto || (window as any).msCrypto;
            return crypto.randomUUID();
        };

        let customBigCanvasAndZoom = function (width, height, zoomin) {
            //TODO: LAURA SE HA QUEDADO A MEDIAS!!!!!!!!!!!!!!!!!!!!!
            //hacemos mas grande todo
            $scope.canvas.setWidth(width);
            $scope.canvas.setHeight(height);
            $scope.canvas.setZoom(1);
            $scope.canvas.setZoom($scope.canvas.getZoom() * zoomin);

            //$scope.canvas.renderAll();

            const delta = new fabric.Point(0, 0);
            $scope.canvas.relativePan(delta);

        };
        
        fabric.Group.prototype._toSVG = (function(_toSVG){
            return function(){
                let svg = _toSVG.call(this);
                if(this.options) {
                    svg[2] = " options=\"" + JSON.stringify(this.options)
                        .replaceAll("\"", "'") + "\">";
                }
                if((this.localType === "zone" || this.localType === "table") && svg[0].indexOf("localType") === -1) {
                    svg[0] += " localType=\"" + this.localType + "\" "
                        + " guid=\"" + this.guid + "\" ";
                }
                return svg;
            }
        })(fabric.Group.prototype._toSVG);

        fabric.Textbox.prototype._toSVG = (function(_toSVG){
            return function(){
                let svg = _toSVG.call(this);
                if(this.options && svg[1].indexOf("prefered_position") === -1) {
                    svg[1] += " prefered_position=\"" + this.options.id + "\" ";
                }
                if(this.customSvgClass && svg[1].indexOf("class") === -1) {
                    svg[1] += " class=\"" + this.customSvgClass + "\" ";
                }

                return svg;
            }
        })(fabric.Textbox.prototype._toSVG);

        fabric.Rect.prototype._toSVG = (function(_toSVG){
            return function(){
                let svg = _toSVG.call(this);
                if (this.options && svg[0].indexOf("prefered_position") === -1) {
                    svg[0] += " prefered_position=\"" + this.options.zone_prefered + "\" ";
                }
                if (this.customSvgClass && svg[0].indexOf("class") === -1) {
                    svg[0] += " class=\"" + this.customSvgClass + "\" ";
                }
                return svg;
            }
        })(fabric.Rect.prototype._toSVG);

        fabric.Circle.prototype._toSVG = (function(_toSVG){
            return function(){
                let svg = _toSVG.call(this);
                if (this.options && svg[0].indexOf("prefered_position") === -1) {
                    svg[0] += " prefered_position=\"" + this.options.zone_prefered + "\" ";
                }
                if(this.customSvgClass && svg[0].indexOf("class") === -1) {
                    svg[0] += " class=\"" + this.customSvgClass + "\" ";
                }

                return svg;
            }
        })(fabric.Circle.prototype._toSVG);

        $scope.saveSpace = function (continueOpen) {

            findZonePositions();

            $scope.space.canvas = $scope.canvas.toJSON(['options', 'lockMovementX', 'lockMovementY', 'localType', 'guid', 'custom', 'guests', 'customSvgClass']);
            let tmp = $scope.space.items;
            delete $scope.space.items;
            $scope.space.canvas.objects = $scope.space.canvas.objects.reduce(function (pre, curr) { if (curr.type !== "path") pre.push(curr); return pre;}, []);

            //quitamos los textbox que son nombres que están duplicados en las mismas posiciones
            //en algun momento se han generado duplicados en el canvas
            $scope.space.canvas.objects.forEach(function (obj) {
                if (obj.type == "group") {
                    let finalObjects:any[] = [];
                    obj.objects.forEach(function (subObj) {
                        if(subObj.type == "textbox"){
                            //comprobamos si ya existe otro objeto del mismo tipo, texto, left y top
                            let objectFound = finalObjects.find(m => m.type == "textbox" && m.text == subObj.text && m.left == subObj.left && m.top == subObj.top);
                            if (!objectFound) finalObjects.push(subObj);
                        }else{
                            finalObjects.push(subObj);
                        }
                    });
                    obj.objects = finalObjects;
                }
            });

            //guardamos viewportTransform para restaurarlo al abrir de nuevo
            $scope.space.viewportTransform = $scope.canvas.viewportTransform;

            //comprobar que tengan nombre las zonas
            let errorZoneName = false;
            angular.forEach($scope.space.canvas.objects, function (object) {
                if (object.localType == "zone" && (object.options == null || object.options.name == null || object.options.name == '')) {
                    errorZoneName = true;
                }
            });
            if (errorZoneName) {
                var errorMessage = $filter('translate')('events.spaces.error_zone_name_required');
                toastr.error(errorMessage);
                return;
            }
            
            removeBox();

            $scope.spaceDTO.configuration = JSON.stringify($scope.space);

            //logService.debug($scope.space);

            $scope.canvas.discardActiveObject();
            $scope.canvas.renderAll();
            if (!$scope.$$phase) $scope.$apply();

            $scope.spaceDTO.svg = $scope.canvas.toSVG({
                width: $scope.spaceDTO.width,
                height: $scope.spaceDTO.height,
                viewBox: {
                    x: 0,
                    y: 0,
                    width: $scope.spaceDTO.width,
                    height: $scope.spaceDTO.height
                }
            });

            if ($scope.spaceDTO.id > 0) {
                if (inSpaceEvents) {
                    Restangular.all('EventsSpaces').customPUT($scope.spaceDTO, "/" + $scope.spaceDTO.id).then(function (result) {
                        // $scope.zones = eventService.getSpaceZones($stateParams.id, id).$object;
                        if(continueOpen === 1) {
                            addBox();
                        }

                        $scope.space.items = tmp;
                        if (typeof (result.id) != "undefined") {
                            toastr.success($filter('translate')('events.spaces.edit_success'));
                            if (angular.isDefined($scope.gridOptionsSpaces)) $scope.gridOptionsSpaces.loadData();
                            if (continueOpen == 0) $uibModalInstance.close($scope.options);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    }, function (error) {
                        logService.error(error);
                        let errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
                    });
                } else {
                    Restangular.all('Spaces').customPUT($scope.spaceDTO, "/" + $scope.spaceDTO.id).then(function (result) {
                        // $scope.zones = eventService.getSpaceZones($stateParams.id, id).$object;
                        if(continueOpen === 1) {
                            addBox();
                        }

                        $scope.space.items = tmp;
                        if (typeof (result.id) != "undefined") {
                            toastr.success($filter('translate')('events.spaces.edit_success'));
                            if (angular.isDefined($scope.gridOptionsSpaces)) $scope.gridOptionsSpaces.loadData();
                            if (continueOpen == 0) $uibModalInstance.close($scope.options);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    }, function (error) {
                        logService.error(error);
                        let errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
                    });
                }
            } else {
                if (inSpaceEvents) {
                    Restangular.all('EventsSpaces').post($scope.spaceDTO).then(function (result) {
                        // $scope.zones = eventService.getSpaceZones($stateParams.id, id).$object;
                        if(continueOpen === 1) {
                            addBox();
                        }

                        $scope.space.items = tmp;
                        if (typeof (result.id) !== "undefined") {
                            $scope.spaceDTO = result;
                            toastr.success($filter('translate')('events.spaces.add_success'));
                            if (angular.isDefined($scope.gridOptionsSpaces)) $scope.gridOptionsSpaces.loadData();
                            if (continueOpen == 0) $uibModalInstance.close($scope.options);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                        if (!$scope.$$phase) $scope.$apply();
                    }, function (error) {
                        logService.error(error);
                        let errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
                    });
                } else {
                    Restangular.all('Spaces').post($scope.spaceDTO).then(function (result) {
                        // $scope.zones = eventService.getSpaceZones($stateParams.id, id).$object;
                        if(continueOpen === 1) {
                            addBox();
                        }

                        $scope.space.items = tmp;
                        if (typeof (result.id) !== "undefined") {
                            $scope.spaceDTO = result;
                            toastr.success($filter('translate')('events.spaces.add_success'));
                            if (angular.isDefined($scope.gridOptionsSpaces)) $scope.gridOptionsSpaces.loadData();
                            if (continueOpen == 0) $uibModalInstance.close($scope.options);
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    }, function (error) {
                        logService.error(error);
                        let errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
                    });
                    if (!$scope.$$phase) $scope.$apply();

                }
            }
            //$scope.resetZoom();

        };

        $scope.cancelMain = function () {
            $uibModalInstance.dismiss('cancel');
            if (angular.isDefined($scope.gridOptionsSpaces)) $scope.gridOptionsSpaces.loadData();
        };

        $scope.resetZoom = function () {
            $scope.canvas.setZoom(1);
            $scope.space.zoom = $scope.canvas.getZoom();
        };
        $scope.zoomIn = function () {
            $scope.canvas.setZoom($scope.canvas.getZoom() * 1.1);
            $scope.space.zoom = $scope.canvas.getZoom();
            $scope.canvas.renderAll();
        };
        $scope.zoomOut = function () {
            $scope.canvas.setZoom($scope.canvas.getZoom() / 1.1);
            $scope.space.zoom = $scope.canvas.getZoom();
            $scope.canvas.renderAll();
        };

        $scope.deltaUnits = 30;
        $scope.goRight = function () {
            let delta = new fabric.Point($scope.deltaUnits, 0);
            $scope.canvas.relativePan(delta);
        };
        $scope.goLeft = function () {
            let delta = new fabric.Point(-$scope.deltaUnits, 0);
            $scope.canvas.relativePan(delta);
        };
        $scope.goDown = function () {
            let delta = new fabric.Point(0, $scope.deltaUnits);
            $scope.canvas.relativePan(delta);
        };
        $scope.goUp = function () {
            let delta = new fabric.Point(0, -$scope.deltaUnits);
            $scope.canvas.relativePan(delta);
        };

        $scope.dataURLtoBlob = function (dataurl) {
            const arr = dataurl.split(','), mime =  dataurl.split(',')[0].split(':')[1].split(';')[0],
                bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        };
        
        $scope.switchFullScreenCanvas = function () {
            $scope.spaceCanvasFullWidth = !$scope.spaceCanvasFullWidth;
            $scope.canvas.renderAll();
            if (!$scope.$$phase) $scope.$apply();
        };

        $scope.downloadImage = function () {

            logService.debug('$scope.canvas');
            logService.debug($scope.canvas);

            //$scope.canvas.deactivateAll().renderAll();

            $scope.canvas.renderAll();

            const a = document.createElement('a');
            a.download = $scope.spaceDTO.name + ".jpeg";
            const blob = $scope.dataURLtoBlob($scope.canvas.toDataURL('image/jpeg', 1.0));
            const objurl = URL.createObjectURL(blob);
            a.href = objurl;
            a.click();

            //lo quitamos
            $(a).remove();

        };

        //añadimos mesa
        $scope.createTable = function (item, click_x, click_y) {

            const modalInstance = $uibModal.open({
                template: SpaceItemTableModalView,
                controller: "SpaceTableCtrl",
                //size: "sm",
                scope: $scope,
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (options) {

                const placeWidth = 70;//20;
                const placeHeight = 70;// 20;
                const placeMargin = 8;//5;

                let places = [];
                if (typeof options.name === 'undefined') options.name = "";


                let angle = 0;
                if (options.positions_header == "up") {
                    angle = 90;
                } else if (options.positions_header == "down") {
                    angle = -90;
                } else if (options.positions_header == "right") {
                    angle = 180;
                }


                //creamos plazas
                if (options.type == "round") {

                    //creamos base de zona
                    let angleCircle = 0;
                    var step = (2 * Math.PI) / options.places;
                    var radius = options.places * 12;

                    let backgroundColor = typeof options.color !== "undefined" ? options.color : $scope.zone_color;

                    var tableRect = new fabric.Circle({
                        /*left: -placeMargin,
                        top: -((placeHeight + placeMargin) * (nRows - 1) + placeMargin),*/
                        left: 0,
                        top: 0,
                        radius: radius,
                        fill: backgroundColor,
                        strokeWidth: 1,
                        strokeColor: 'black'
                    });
                    places.push(tableRect);

                    //ponemos denominacion
                    if (options.name != "") {
                        var fontSize = 14;
                        var placeText = new fabric.Textbox("" + options.name, {
                            left: radius,
                            top: radius - fontSize / 2,
                            width: radius * 2,
                            height: fontSize,
                            fontSize: fontSize,
                            textAlign: 'center',
                            originX: "center",
                            originY: "center",
                            angle: -angle
                        });
                        places.push(placeText);
                    }

                    var placeNumber = 1;
                    //obtenemos el array cartesiano de la mesa.
                    var arrayPositions = [];
                    var auxArrayPositions = [];
                    var nPlaceTotalPrefered = options.firstPlaceNumberPrefered;
                    //Definimos el array ordenado.
                    for (var nRow = 0; nRow < options.places; nRow++) {
                        auxArrayPositions.push({ placeNumber: placeNumber, prefered: nPlaceTotalPrefered });
                        placeNumber++;
                        nPlaceTotalPrefered++;
                    }
                    let indexof = 0;
                    let configurationTables: any = [];

                    if (options.system_table == "cartesian") {
                        configurationTables = CONFIG_TABLE["CARTESIAN_" + options.places];

                        arrayPositions = [configurationTables.length];
                        for (var nRow = 0; nRow < configurationTables.length; nRow++) {
                            //Recorremos para organizar las preferencias
                            indexof = _.findIndex(auxArrayPositions, { placeNumber: configurationTables[nRow] });
                            arrayPositions[nRow] = { placeNumber: configurationTables[nRow], prefered: auxArrayPositions[indexof].prefered };
                        }

                    } else if (options.system_table == "clock") {
                        configurationTables = CONFIG_TABLE["CLOCK_" + options.places];

                        arrayPositions = [configurationTables.length];
                        for (var nRow = 0; nRow < configurationTables.length; nRow++) {
                            //Recorremos para organizar las preferencias
                            indexof = _.findIndex(auxArrayPositions, { placeNumber: configurationTables[nRow] });
                            arrayPositions[nRow] = { placeNumber: configurationTables[nRow], prefered: auxArrayPositions[indexof].prefered };
                        }
                    } else {
                        //Si es normal, el array es el mismo.
                        arrayPositions = auxArrayPositions;
                    }
                    

                    //for (var nRow = 0; nRow < options.places; nRow++) {
                    for (var nRow = 0; nRow < arrayPositions.length; nRow++) {
                        //logService.debug(placeNumber, angleCircle, step, angleCircle * 180 / Math.PI);

                        const diffRadius = 20;
                        const outherRadius = radius + diffRadius;
                        var x = Math.round(outherRadius * Math.cos(angleCircle)) - placeWidth / 2 + outherRadius - diffRadius;
                        var y = Math.round(outherRadius * Math.sin(angleCircle)) - placeHeight / 2 + outherRadius - diffRadius;

                        placeNumber = arrayPositions[nRow].placeNumber;
                        nPlaceTotalPrefered = arrayPositions[nRow].prefered;
                        if (isNaN(nPlaceTotalPrefered)) nPlaceTotalPrefered = "";

                        const placeRect = new fabric.Circle({
                            left: x,
                            top: y,
                            //width: placeWidth,
                            //height: placeHeight,
                            radius: placeWidth / 2,
                            fill: $scope.place_color_free,
                            //angle: angle * 180 / Math.PI,
                            options: {
                                droppable: true,
                                zone: options.name || "",
                                zone_type: "table",
                                zone_file: 1,
                                zone_position: placeNumber,
                                zone_prefered: nPlaceTotalPrefered + "",
                                locked: false
                            },
                            customSvgClass: "guestNameRect"
                        });
                        places.push(placeRect);

                        fontSize = 10;
                        var left = x + (placeWidth / 5);
                        var top = y + (placeHeight / 5);
                      
                        if (angle == 180) {
                            top = y + placeHeight - (placeWidth / 5);
                            left = x + placeWidth - (placeHeight / 5);

                        } else if (angle == 90) {
                            top = y + placeHeight;
                        } else if (angle == -90) {
                            left = x + placeWidth;
                        }
                        
                        var placeText = new fabric.Textbox("" + placeNumber, {
                            //backgroundColor: '#FFFFFF',
                            left: left - 3,
                            top: top - 3,
                            width: placeWidth,
                            height: placeHeight,
                            fontSize: fontSize,
                            textAlign: 'center',
                            originX: "center",
                            originY: "center",
                            angle: -angle,
                            customSvgClass: "seatNumber"
                        });
                        places.push(placeText);

                        //texto de precedencia
                        if (typeof (nPlaceTotalPrefered) !== 'undefined' && nPlaceTotalPrefered != "") {
                            var left = x + (placeWidth / 2);
                            var top = y;
                            if (angle == 180) {
                                top = y + (placeHeight);
                            } else if (angle == 90) {
                                left = x;
                                top = y + (placeHeight / 2);
                            } else if (angle == -90) {
                                top = y + (placeHeight / 2);
                                left = x + placeWidth;
                            }
                            var placeText = new fabric.Textbox(nPlaceTotalPrefered + "", {
                                left: left,
                                top: top - 2,
                                width: placeWidth,
                                height: placeHeight,
                                fontSize: 14,
                                textAlign: 'center',
                                fontWeight: 'bold',
                                originX: "center",
                                originY: "center",
                                angle: -angle,
                                customSvgClass: "preferred"
                            });
                            places.push(placeText);
                            //nPlaceTotalPrefered += (options.onlyPairNone ? 2 : 1);
                        }

                        angleCircle += step;
                        //placeNumber++;
                    }

                } else if (options.type == "rect") {


                    let backgroundColor = typeof options.color !== "undefined" ? options.color : $scope.zone_color;

                    if (options.system_table == "single_head") {
                        var width = Math.ceil((options.places - 1) / 2) * (placeWidth + placeMargin);
                    }
                    if (options.type_presidency_table == "english" && options.system_table != "single_head") {
                        //Tiene los dos laterales
                        var width = Math.ceil((options.places - 2) / 2) * (placeWidth + placeMargin);
                    }

                    if (options.type_presidency_table == "french" && options.system_table != "single_head") {
                        if (options.head_table == "no_head") {
                            var width = Math.ceil((options.places) / 2) * (placeWidth + placeMargin);
                        } else {
                            if (options.places % 2 == 0) {
                                var width = Math.ceil((options.places - 2) / 2) * (placeWidth + placeMargin);
                            } else {
                                var width = Math.ceil((options.places - 1) / 2) * (placeWidth + placeMargin);
                            }
                            
                        }
                    }

                    let height = (options.places_left > options.places_right ? options.places_left : options.places_right) * (placeHeight + placeMargin);


                    //aseguramos minimo 1 palza ancho
                    if (width == 0) width = (placeWidth + placeMargin * 2);
                    if (height == 0) height = (placeHeight + placeMargin * 2);

                    width += placeMargin;
                    height += placeMargin;
                    

                    //creamos base de zona
                    var step = (2 * Math.PI) / options.places;
                    var radius = 50;
                    var tableRect = new fabric.Rect({
                        left: 0,
                        top: 0,
                        width: width,
                        height: height,
                        fill: backgroundColor,
                        strokeWidth: 1,
                        strokeColor: '#444444',
                    });
                    places.push(tableRect);

                    //ponemos denominacion
                    let angleText = (angle == 180 ? angle : 0);
                    if (options.name != "") {
                        var fontSize = 12;
                        var placeText = new fabric.Textbox("" + options.name, {
                            left: (width/2),
                            top: (height - fontSize) / 2,
                            originX: "center" ,
                            originY: "center" ,
                            width: width,
                            height: height,
                            fontSize: fontSize,
                            textAlign: 'center',
                            angle: angleText
                        });
                        places.push(placeText);
                    }
                    
                    var placeNumber = 1;
                    //obtenemos el array cartesiano de la mesa.
                    var arrayPositions = [];
                    var auxArrayPositions = [];
                    var nPlaceTotalPrefered = options.firstPlaceNumberPrefered;

                    //Definimos el array ordenado.
                    for (var nRow = 0; nRow < options.places; nRow++) {
                        auxArrayPositions.push({ placeNumber: placeNumber, prefered: nPlaceTotalPrefered });
                        placeNumber++;
                        nPlaceTotalPrefered++;
                    }


                    /*************************************************************************************************
                    * DEFINIMOS EL ARRAY CON LO DATOS
                    *************************************************************************************************/
                    let configurationTables: any = [];
                    if (options.system_table == "cartesian") {
                        if (options.type_presidency_table == "english") {
                            configurationTables = CONFIG_TABLE["CARTESIAN_" + options.places];
                        } else {
                            configurationTables = CONFIG_TABLE_FRENCH["CARTESIAN_" + options.places];
                        }

                        arrayPositions = [configurationTables.length];
                        for (var nRow = 0; nRow < configurationTables.length; nRow++) {
                            //Recorremos para organizar las preferencias
                            let indexof = _.findIndex(auxArrayPositions, { placeNumber: configurationTables[nRow] });
                            arrayPositions[nRow] = { placeNumber: configurationTables[nRow], prefered: auxArrayPositions[indexof].prefered };
                        }

                    } else if (options.system_table == "clock") {
                        if (options.type_presidency_table == "english") {
                            configurationTables = CONFIG_TABLE["CLOCK_" + options.places];
                        } else {
                            configurationTables = CONFIG_TABLE_FRENCH["CLOCK_" + options.places];
                        }

                        arrayPositions = [configurationTables.length];
                        for (var nRow = 0; nRow < configurationTables.length; nRow++) {
                            //Recorremos para organizar las preferencias
                            let indexof = _.findIndex(auxArrayPositions, { placeNumber: configurationTables[nRow] });
                            arrayPositions[nRow] = { placeNumber: configurationTables[nRow], prefered: auxArrayPositions[indexof].prefered };
                        }
                    } else {
                        //Si es normal, el array es el mismo.
                        arrayPositions = auxArrayPositions;
                    }

                    /*************************************************************************************************
                    * CABECERA UNICA
                    *************************************************************************************************/
                    if (options.system_table == "single_head") {

                        let places_left = [];
                        let places_bottom = [];
                        let places_top = [];
                        var x = -1 * (placeWidth + placeMargin);
                        var y = 1;
                        places_left.push(arrayPositions[0]);

                        for (var i = 1; i < options.places; i = i + 2) {
                            if (i < options.places) places_bottom.push(arrayPositions[i]);
                        }
                        for (var i = 2; i < options.places; i = i + 2) {
                            if (i < options.places) places_top.push(arrayPositions[i]);
                        }
                        
                        places = defineTable(-1 * (placeWidth + placeMargin), 1, false, true, places, places_left, placeWidth, placeHeight, placeMargin, options, angle);//left                            
                        places = defineTable(1, -1 * (placeHeight + placeMargin), true, false, places, places_top, placeWidth, placeHeight, placeMargin, options, angle);//top                            
                        places = defineTable(1, height + placeMargin, true, false, places, places_bottom, placeWidth, placeHeight, placeMargin, options, angle);//bottom
                      
                    }

                    /*************************************************************************************************
                    * INGLESA
                    *************************************************************************************************/

                    if (options.type_presidency_table == "english" && options.system_table != "single_head") {
                        //en la inglesa siempre tienen cabecera. 
                        var posiSecond = _.findIndex(arrayPositions, { placeNumber: 2 });

                        //left
                        let places_left = [];
                        var x = -1 * (placeWidth + placeMargin);
                        var y = 1; //(nRow * (placeHeight + placeMargin)) + placeMargin;
                        places_left.push(arrayPositions[0]);
                        places = defineTable(x, y, false, true, places, places_left, placeWidth, placeHeight, placeMargin, options, angle);

                        //top
                        let places_top = [];
                        var x = 1;// (nRow * (placeWidth + placeMargin)) + placeMargin;
                        var y = -1 * (placeHeight + placeMargin);
                        for (var i = 1; i < posiSecond; i++) {
                            if (i < options.places) places_top.push(arrayPositions[i]);
                        }
                        places = defineTable(x, y, true, false, places, places_top, placeWidth, placeHeight, placeMargin, options, angle);

                        //right
                        let places_right = [];
                        var x = width + placeMargin;
                        var y = 1;//(nRow * (placeHeight + placeMargin)) + placeMargin;
                        places_right.push(arrayPositions[posiSecond]);
                        places = defineTable(x, y, false, true, places, places_right, placeWidth, placeHeight, placeMargin, options, angle);

                        //bottom
                        let places_bottom = [];
                        var x = 1;// (nRow * (placeWidth + placeMargin)) + placeMargin;
                        var y = height + placeMargin;
                        for (var i = arrayPositions.length - 1; i > posiSecond; i--) {
                            if (i < options.places) places_bottom.push(arrayPositions[i]);
                        }
                        places = defineTable(x, y, true, false, places, places_bottom, placeWidth, placeHeight, placeMargin, options, angle);


                    }

                    /*************************************************************************************************
                    * FRANCESA
                    *************************************************************************************************/
                    if (options.type_presidency_table == "french" && options.system_table != "single_head") {
                        if (options.head_table == "no_head") {

                            //top
                            let places_top = [];
                            var x = 1;
                            var y = -1 * (placeHeight + placeMargin);
                            let maxI = Math.ceil(arrayPositions.length / 2);
                            if (options.places % 2 == 0) {
                                maxI = Math.ceil(arrayPositions.length / 2);
                            }

                            for (var i = 0; i < maxI; i++) {
                                 places_top.push(arrayPositions[i]);
                            }
                            places = defineTable(x, y, true, false, places, places_top, placeWidth, placeHeight, placeMargin, options, angle);

                            //bottom
                            let places_bottom = [];
                            var x = 1;// (nRow * (placeWidth + placeMargin)) + placeMargin;
                            var y = height + placeMargin;
                            for (var i = arrayPositions.length - 1; i > Math.ceil(arrayPositions.length / 2) - 1; i--) {
                                places_bottom.push(arrayPositions[i]);
                            }
                            places = defineTable(x, y, true, false, places, places_bottom, placeWidth, placeHeight, placeMargin, options, angle);

                        } else {

                            if (options.places % 2 == 0) {
                                var posiSecond = Number(options.places) / 2;
                            } else {
                                var posiSecond = (Number(options.places)+1) / 2;
                            }

                            //left
                            let places_left = [];
                            var x = -1 * (placeWidth + placeMargin);
                            var y = 1; //(nRow * (placeHeight + placeMargin)) + placeMargin;
                            places_left.push(arrayPositions[0]);
                            places = defineTable(x, y, false, true, places, places_left, placeWidth, placeHeight, placeMargin, options, angle);

                            //top
                            let places_top = [];
                            var x = 1;// (nRow * (placeWidth + placeMargin)) + placeMargin;
                            var y = -1 * (placeHeight + placeMargin);
                            for (var i = 1; i < posiSecond; i++) {
                                if (_.findIndex(places_top, { placeNumber: arrayPositions[i].placeNumber }) == -1) {
                                    if (i < options.places) places_top.push(arrayPositions[i]);
                                }
                            }
                            places = defineTable(x, y, true, false, places, places_top, placeWidth, placeHeight, placeMargin, options, angle);

                            //right
                            if (options.places % 2 == 0) {
                                //es par, por lo tanto, habrá en izquierda y en derecha

                                let places_right = [];
                                var x = width + placeMargin;
                                var y = 1;//(nRow * (placeHeight + placeMargin)) + placeMargin;
                                places_right.push(arrayPositions[posiSecond]);
                                places = defineTable(x, y, false, true, places, places_right, placeWidth, placeHeight, placeMargin, options, angle);
                            }                            
                            
                            //bottom
                            let places_bottom: any = [];
                            if (options.places % 2 == 0)  posiSecond = posiSecond + 1; //ya que ponemos el right
                            var x = 1;// (nRow * (placeWidth + placeMargin)) + placeMargin;
                            var y = height + placeMargin;

                            for (var i = arrayPositions.length - 1; i > posiSecond - 1; i--) {
                                if (_.findIndex(places_bottom, { placeNumber: arrayPositions[i].placeNumber }) === -1) {
                                    places_bottom.push(arrayPositions[i]);
                                }                                    
                            }
                            places = defineTable(x, y, true, false, places, places_bottom, placeWidth, placeHeight, placeMargin, options, angle);

                        }
                    }
                }

                const zone = new fabric.Group(places, {
                    localType: "table",
                    guid: $scope.guid(),
                    left: click_x,
                    top: click_y,
                    lockScalingX: true,
                    lockScalingY: true,
                    strokeWidth: 0,
                    padding: 0,
                    angle: angle,
                    originX: "center",
                    originY: "center",
                    options: options,
                    subTargetCheck: true
                });

                if (item != null) {
                    zone.left = item.left;
                    zone.top = item.top;
                    //zone.setAngle(item.getAngle()); //ya está controlado el angulo
                    $scope.space.items[$scope.space.items.indexOf(item)] = zone;
                } else {
                    $scope.space.items.push(zone);
                }

                $scope.drawSpace(false);

                //asignamos invitados ubicados antes de edición de zona
                if(item!=null) $scope.reasignGuestToZone(item.guests, zone);

            }, function () {
                //dimissed
            });
        };
        
        var defineTable = function (x, y, fixedValuex, fixedValuey, places, values, placeWidth, placeHeight, placeMargin, options, angle) {
            for (let nRow = 0; nRow < values.length; nRow++) {
                const fixedValue = (nRow * (placeHeight + placeMargin)) + placeMargin;
                if (fixedValuex) {
                    x = fixedValue;
                } 
                if (fixedValuey) {
                    y = fixedValue;
                }

                const placeRect = new fabric.Rect({
                    left: x,
                    top: y,
                    width: placeWidth,
                    height: placeHeight,
                    fill: $scope.place_color_free,
                    options: {
                        droppable: true,
                        zone: options.name || "",
                        zone_type: "table",
                        zone_file: 1,
                        zone_position: values[nRow].placeNumber,
                        zone_prefered: values[nRow].prefered,
                        locked: false
                    }
                });
                places.push(placeRect);

                var left = x + 1;
                var top = y + 1;
                if (angle == 90) {
                    top = top + placeWidth;
                } else if (angle == -90) {
                    left = x + placeWidth;
                } else if (angle == 180) {
                    top = top + placeHeight;
                    left = left + placeWidth;
                }
                var placeText = new fabric.Textbox("" + values[nRow].placeNumber, {
                    left: left,
                    top: top,
                    width: placeWidth,
                    height: placeHeight,
                    fontSize: 7,
                    originX: "center",
                    originY: "center",
                    textAlign: 'center',
                    angle: -angle,
                    customSvgClass: "preferred"
                });
                places.push(placeText);

                var left = x + (placeWidth / 2);
                var top = y;

                if (angle == 90) {
                    left = x;
                    top = y+(placeHeight / 2);
                } else if (angle == -90) {
                    left = x + placeWidth;
                    top = y + (placeHeight / 2);
                } else if (angle == 180) {
                    top = y + placeHeight;
                }

                //texto de precedencia
                if (typeof (values[nRow].prefered) !== 'undefined') {
                    var placeText = new fabric.Textbox(values[nRow].prefered + "", {
                        left: left,
                        top: top  ,
                        width: placeWidth,
                        height: placeHeight,
                        fontSize: 12,
                        textAlign: 'center',
                        fontWeight: 'bold',
                        originX: "center",
                        originY: "center",
                        angle: -angle,
                        customSvgClass: "preferred"
                    });
                    places.push(placeText);
                }
            }
            return places;
        }

        //generamos invitados en zona
        $scope.reasignGuestToZone = function (guests, zone) {
            angular.forEach(guests, function (guest) {
                //asignamos posicion
                $scope.addGuestToObject(zone, guest.file, guest.position, guest.prefered, guest.locked, guest.event_guest_id, guest.name_guest, guest.color_guest, guest.position);

            });
        };


        //añadimos objeto
        $scope.createImage = function (item, image, click_x, click_y) {
            // var url = '/assets/img/spaces/' + image + '.png';
            let url = (window as any).CONFIG.api_url + 'files/' + image + '/download';
            fabric.Image.fromURL(url, function (oImg) {
                //canvas.add(oImg);
                oImg.localType = "image";
                oImg.guid = $scope.guid();
                oImg.lockScalingX = false;
                oImg.lockScalingY = false;
                oImg.left = click_x;
                oImg.top = click_y;
                oImg.originX = "center";
                oImg.originY = "center";
                oImg.options = {
                    url: url,
                    uid: image
                };

                if (item != null) {
                    oImg.left = item.left;
                    oImg.top = item.top;
                    $scope.space.items[$scope.space.items.indexOf(item)] = oImg;
                } else {
                    $scope.space.items.push(oImg);
                }

                $scope.drawSpace(false);
            });

        };

        //añadimos zona
        $scope.createZone = function (item, click_x, click_y) {
            $scope.modalOpened = true;

            const modalInstance = $uibModal.open({
                template: SpaceItemZoneModalView,
                controller: "SpaceItemCtrl",
                scope: $scope,
                //size: "sm",
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (options) {

                let angle = 0;
                if (options.positions_header == "up") {
                    angle = 180;
                } else if (options.positions_header == "left") {
                    angle = 90;
                } else if (options.positions_header == "right") {
                    angle = -90;
                }

                const nRows = options.rows;
                const nPlaces = options.places;
                const placeWidth = 70; //20;
                const placeMargin = 8; // 5;
                const placeHeight = 70;//20;

                let backgroundColor = typeof options.color !== "undefined" ? options.color : $scope.zone_color;

                const places = [];

                //creamos base de zona
                if (options.placesDirection2 == "up") {
                    var placeRect = new fabric.Rect({
                        left: -placeMargin,
                        top: -((placeHeight + placeMargin) * (nRows - 1) + placeMargin),
                        width: ((placeWidth + placeMargin) * nPlaces) + placeMargin,
                        height: ((placeHeight + placeMargin) * nRows) + placeMargin,
                        fill: backgroundColor
                    });
                } else {
                    var placeRect = new fabric.Rect({
                        left: -placeMargin,
                        top: -placeMargin,
                        width: ((placeWidth + placeMargin) * nPlaces) + placeMargin,
                        height: ((placeHeight + placeMargin) * nRows) + placeMargin,
                        fill: backgroundColor
                    });
                }
                    
                if (options.placesDirection == "left") {
                    placeRect.left = -((placeWidth + placeMargin) * (nPlaces - 1)) - placeMargin;
                }
                places.push(placeRect);

                //generamos filas                
                var nPlaceTotal = options.firstPlaceNumber;
                let nPlaceTotalPrefered = options.firstPlaceNumberPrefered;

                for (let nRow = 0; nRow < nRows; nRow++) {
                    let left = 0;
                    if (options.placesDirection2 == "up") {
                        var top = -(placeHeight + placeMargin) * nRow;
                    } else {
                        var top = (placeHeight + placeMargin) * nRow;
                    }

                    if (options.resetPlaceNumberByRow) {
                        nPlaceTotal = options.firstPlaceNumber;
                    }

                    //ponemos numero de fila a la izquierda o derecha
                    let rowNumber = "" + (parseInt(options.firstRowNumber) + nRow);
                    if (options.rowsNumberLikeChars) {
                        rowNumber = String.fromCharCode(65 + (parseInt(options.firstRowNumber) + nRow));
                    }
                    var placeText = new fabric.Text(rowNumber, {
                        left: left + (options.placesDirection == "left" ? placeWidth+5 : -(placeMargin / 2)-5),
                        top: top + (placeHeight / 2) - 5,
                        width: placeWidth,
                        height: placeHeight,
                        fontSize: 10,
                        textAlign: 'center',
                        angle: -angle,
                        originX: "center",
                        originY: "center",
                        customSvgClass: "rowNumber"
                    });
                    places.push(placeText);

                    let centerArray: any = null;
                    if (options.placesDirection == "center") {
                        //Construimos el array centrado y lo pinta como si la direccion fuese right
                        centerArray = [nPlaces];
                        let pos = Math.floor(nPlaces / 2);
                        let count = 1;
                        var nPlaceTotal = options.firstPlaceNumber;
                        //construyo el array
                        for (let i = 0; i < nPlaces; i++) {
                            centerArray[pos] = { column: nPlaceTotal, prefered: nPlaceTotalPrefered };
                            //si es impar
                            if (nPlaces % 2 == 0) {
                                if (i % 2 == 0) {
                                    pos = pos - count;
                                } else {
                                    pos = pos + count;
                                }
                            } else {
                                //Es par, va al reves
                                if (i % 2 == 0) {
                                    pos = pos + count;
                                } else {
                                    pos = pos - count;
                                }
                            }
                            count++;
                            nPlaceTotalPrefered += (options.onlyPairNone ? 2 : 1);
                            nPlaceTotal += (options.onlyPairNone ? 2 : 1);
                        }
                    }
                    //pintamos asientos
                    for (let nPlace = 0; nPlace < nPlaces; nPlace++) {
                        left = (options.placesDirection == "left" ? -1 : 1) * (placeWidth + placeMargin) * nPlace;
                        //asiento
                        var placeRect = new fabric.Rect({
                            left: left,
                            top: top,
                            width: placeWidth,
                            height: placeHeight,
                            fill: $scope.place_color_free,
                            options: {
                                droppable: true,
                                zone: options.name || "",
                                zone_type: "zone",
                                zone_file: rowNumber,
                                zone_position: (options.placesDirection != "center" ? "" + nPlaceTotal : "" + centerArray[nPlace].column),
                                zone_prefered: (options.placesDirection != "center" ? nPlaceTotalPrefered : centerArray[nPlace].prefered),
                                locked: false
                            }
                        });
                        placeRect.on('mousedown', function(e) {
                            logService.debug(e.target);
                        });
                        places.push(placeRect);

                        var leftText = left + (placeMargin / 2);
                        var topText = top + (placeMargin - 2);
                        //texto de asiento
                        var placeText = new fabric.Textbox((options.placesDirection != "center" ? "" + nPlaceTotal : "" + centerArray[nPlace].column), {
                            //backgroundColor: '#FFFFFF',
                            left: leftText,
                            top: topText,
                            /*width: placeWidth,
                            height: placeHeight,*/
                            fontSize: 7,
                            textAlign: 'left',
                            angle: -angle,
                            originX: "center",
                            originY: "center",
                            customSvgClass: "seatNumber"
                        });
                        places.push(placeText);

                        //texto de precedencia
                        if (typeof (nPlaceTotalPrefered) !== 'undefined') {
                            var leftText = left + (placeWidth / 2);
                            var topText = top - (placeMargin/2);
                            if (angle == 90) {
                                leftText = left;
                                topText = top + (placeHeight / 2);
                            } else if (angle == -90) {
                                leftText = left + placeWidth;
                                topText = top + (placeHeight / 2);
                            } else if (angle == 180) {
                                topText = top + placeHeight;
                            }

                            var placeText = new fabric.Textbox((options.placesDirection != "center" ? "" + nPlaceTotalPrefered : "" + centerArray[nPlace].prefered), {
                                left: leftText,
                                top: topText ,
                                width: placeWidth,
                                height: placeHeight,
                                fontSize: 12,
                                textAlign: 'center',
                                fontWeight: 'bold',
                                angle: -angle,
                                originX: "center",
                                originY: "center",
                                customSvgClass: "preferred"
                            });
                            places.push(placeText);
                            if (options.placesDirection != "center") { nPlaceTotalPrefered += (options.onlyPairNone ? 2 : 1); }
                        }
                        if (options.placesDirection != "center") { nPlaceTotal += (options.onlyPairNone ? 2 : 1); }
                    }
                    
                }

                const zone = new fabric.Group(places, {
                    localType: "zone",
                    guid: $scope.guid(),
                    left: click_x,
                    top: click_y,
                    lockScalingX: true,
                    lockScalingY: true,
                    strokeWidth: 0,
                    padding: 0,
                    angle: angle,
                    originX: "center",
                    originY: "center",
                    options: options,
                    subTargetCheck: true
                });

                if (item != null) {
                    zone.left = item.left;
                    zone.top = item.top;
                    //zone.setAngle(item.getAngle());

                    $scope.space.items[$scope.space.items.indexOf(item)] = zone;
                } else {
                    $scope.space.items.push(zone);
                }


                $scope.drawSpace(false);

                if(item != null) {
                    //asignamos invitados ubicados antes de edición de zona
                    $scope.reasignGuestToZone(item.guests, zone);
                }

            }, function () {
                //dimissed
                $scope.modalOpened = false;
            });
        };

        //añadimos coche
        $scope.createVehicle = function (item, click_x, click_y) {
            $scope.modalOpened = true;

            //if (item == null) item = { rows: 2, places: 2 };

            const modalInstance = $uibModal.open({
                template: SpaceItemVehicleModalView,
                controller: "SpaceItemCtrl",
                scope: $scope,
                //size: "sm",
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (options) {

                const nRows = options.rows;
                const nPlaces = options.places;
                let nPlaceTotalPrefered = options.firstPlaceNumberPrefered;

                const placeWidth = 50;// 20;
                const placeMargin = 10;//5;
                const placeHeight = 50;// 20;

                const places = [];

                //creamos dibujo de vehiculo
                var placeRect = new fabric.Rect({
                    left: -placeMargin - 45,
                    top: -((placeHeight + placeMargin) * (nPlaces - 1) + placeMargin) - placeMargin,
                    width: ((placeWidth + placeMargin) * nRows) + placeMargin + 90,
                    height: ((placeHeight + placeMargin) * nPlaces) + 3 * placeMargin,
                    fill: "#e9e9e9"
                });
                places.push(placeRect);
                const ligthRadius = 4;
                var placeRect = new fabric.Circle({
                    radius: ligthRadius,
                    left: -placeMargin - 45 - ligthRadius,
                    top: -((placeHeight + placeMargin) * (nPlaces - 1) + placeMargin) - placeMargin + 10,
                    fill: "#444444"
                });
                places.push(placeRect);
                var placeRect = new fabric.Circle({
                    radius: ligthRadius,
                    left: -placeMargin - 45 - ligthRadius,
                    top: placeHeight - 10,
                    fill: "#444444"
                });
                places.push(placeRect);

                //nombre de vehiculo
                if (options.name != "") {
                    var placeText = new fabric.Textbox(options.name, {
                        left: -placeMargin - 45,
                        top: -((placeHeight + placeMargin) * (nPlaces - 1) + placeMargin) - placeMargin - placeHeight,
                        width: ((placeWidth + placeMargin) * nRows) + placeMargin + 90,
                        height: placeHeight,
                        fontSize: 10,
                        textAlign: 'center'
                    });
                    places.push(placeText);
                }

                //creamos base de zona de asientos
                var placeRect = new fabric.Rect({
                    left: -placeMargin,
                    top: -((placeHeight + placeMargin) * (nPlaces - 1) + placeMargin),
                    width: ((placeWidth + placeMargin) * nRows) + placeMargin,
                    height: ((placeHeight + placeMargin) * nPlaces) + placeMargin,
                    fill: $scope.zone_color
                });
                places.push(placeRect);

                //generamos filas
                var nPlaceTotal = options.firstPlaceNumber;
                for (let nRow = 0; nRow < nRows; nRow++) {

                    //var left = 0;
                    var top = 0;
                    //var top = -(placeHeight + placeMargin) * nRow;

                    const left = (placeWidth + placeMargin) * nRow;

                    //ponemos numero de fila a la izquierda o derecha
                    const rowNumber = "" + (parseInt(options.firstRowNumber) + nRow);

                    //pintamos asientos
                    let nPlaceTotal: any = 1;
                    for (let nPlace = 0; nPlace < nPlaces; nPlace++) {
                        const placeNumber = "" + nPlaceTotal;
                        const placeNumberPrefered = "" + nPlaceTotalPrefered;

                        var top = -(placeHeight + placeMargin) * nPlace;

                        //asiento
                        var placeRect = new fabric.Rect({
                            left: left,
                            top: top,
                            width: placeWidth,
                            height: placeHeight,
                            fill: $scope.place_color_free,
                            options: {
                                droppable: true,
                                zone: options.name || "",
                                zone_type: "zone",
                                zone_file: rowNumber,
                                zone_position: placeNumber,
                                zone_prefered: nPlaceTotalPrefered,
                                locked: false
                            }
                        });
                        places.push(placeRect);

                        //texto de asiento
                        var placeText = new fabric.Textbox(placeNumber, {
                            //backgroundColor: '#FFFFFF',
                            left: left,
                            top: top + 4,
                            width: placeWidth,
                            height: placeHeight,
                            fontSize: 10,
                            textAlign: 'center',
                            customSvgClass: "seatNumber"
                        });
                        places.push(placeText);

                        //texto de precedencia
                        if (typeof (nPlaceTotalPrefered) !== 'undefined') {
                            var placeText = new fabric.Textbox(placeNumberPrefered, {
                                left: left,
                                top: top - (placeMargin),
                                width: placeWidth,
                                height: placeHeight,
                                fontSize: 12,
                                textAlign: 'center',
                                fontWeight: 'bold',
                                customSvgClass: "preferred"
                            });
                            places.push(placeText);
                            nPlaceTotalPrefered += (options.onlyPairNone ? 2 : 1);
                        }
                        nPlaceTotal += (options.onlyPairNone ? 2 : 1);
                    }
                }
                const zone = new fabric.Group(places, {
                    localType: "vehicle",
                    guid: $scope.guid(),
                    left: click_x,
                    top: click_y,
                    lockScalingX: true,
                    lockScalingY: true,
                    strokeWidth: 0,
                    padding: 0,
                    options: options,
                    subTargetCheck: true
                });

                if (item != null) {
                    zone.left = item.left;
                    zone.top = item.top;
                    //zone.setAngle(item.getAngle());
                    $scope.space.items[$scope.space.items.indexOf(item)] = zone;
                } else {
                    $scope.space.items.push(zone);
                }
                $scope.drawSpace(false);

                if(item != null) {
                    //asignamos invitados ubicados antes de edición de zona
                    $scope.reasignGuestToZone(item.guests, zone);
                }
            }, function () {
                //dimissed
                $scope.modalOpened = false;
            });
        };

        $scope.selectedTool = "selector";
        $scope.fillColor = "#000000";
        $scope.strokeColor = "#000000";
        $scope.transparent = false;
        $scope.gridShown = false;
        
        $scope.showGrid = function () {
            if(!$scope.gridShown) {
                addGrid();
            } else {
                removeGrid();
            }
            $scope.gridShown = !$scope.gridShown;
        };
        
        $scope.groupObjects = function () {
            if (!$scope.canvas.getActiveObject()) {
                return;
            }
            if ($scope.canvas.getActiveObject().type !== 'activeSelection') {
                return;
            }
            $scope.canvas.getActiveObject().toGroup();
            $scope.canvas.requestRenderAll();            
        };

        $scope.ungroupObjects = function () {
            if (!$scope.canvas.getActiveObject()) {
                return;
            }
            if ($scope.canvas.getActiveObject().type !== 'group') {
                return;
            }
            $scope.canvas.getActiveObject().toActiveSelection();
            $scope.canvas.requestRenderAll();
        };

        $scope.selectTool = function(tool, transparent) {
            $scope.transparent = transparent;
            $scope.selectedTool = tool;
            $scope.canvas.isDrawingMode = tool !== "selector" && tool !== "text" && tool !== "image";
            $scope.canvas.freeDrawingBrush.color = 'transparent';
            if(tool === "rectangle") {
                $scope.drawRectangle(transparent);
            } else if(tool === "line") {
                $scope.drawLine();
            } else if(tool === "circle") {
                $scope.drawCircle(transparent);
            } else if(tool === "polygon") {
                $scope.drawPolygon(transparent);
            } else if(tool === "text") {
                $scope.drawText();
            } else if(tool === "image") {
                $scope.drawImage();
            } else if(tool === "selector") {
                $scope.removeEvents();
            }
        }
        
        $scope.changeNames = function () {
            let objects = $scope.canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
                let object = objects[i];
                if(object.type === "group") {
                    changeNamesGroup(object);
                }
            }
            $scope.canvas.renderAll();
        }
        
        let findZonePositions = function () {
            let objects = $scope.canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
                let object = objects[i];
                if(object.type === "group") {
                    findZonePositionsRec(object);
                }
            }
        }
        
        let findZonePositionsRec = function (group) {
            if (group.type === "group" && (group.localType === "zone" || group.localType === "table")) {
                let margin = 20;
                group.options.x = Math.round(group.left - (group.width/2) - margin);
                group.options.y = Math.round(group.top - (group.height/2) - margin);
                group.options.width = Math.round(group.width + margin * 2);
                group.options.height = Math.round(group.height + margin * 2);
            }
            for (let i = 0; i < group._objects.length; i++) {
                let object = group._objects[i];
                if(object.type === "group") {
                    findZonePositionsRec(object);
                }
            }
        }
                    
        
        let getPlaceName = function (placeNumber) {
            // Search $scope.gridEventSpaceGuest.data for a place which has the same zone_prefered as placeNumber
            // And return Full Seat Name
            for (let place of allEventGuest) {
                if (place.zone_prefered == placeNumber) {
                    return getFullSeatName(place);
                }
            }
        }
        
        let changeNamesGroup = function (group, guests = null) {
            if(guests == null && group.guests !== undefined) {
                guests = group.guests;
            }
            for (let i = 0; i < group._objects.length; i ++) {
                let object = group._objects[i];
                if(object.type == "group") {
                    changeNamesGroup(object, guests);
                } else if(object.type === "textbox" && object.options !== undefined) {
                    if(!$scope.spaceDTO.useFullname && !$scope.spaceDTO.usePosition) {
                        object.set({text: object.options.id, fontSize: 18, objectCaching: false});
                    } else {
                        let name = getPlaceName(object.options.id);
                        logService.debug("Pongo nombre a " + name + " en " + object.options.id);
                        if(name !== undefined) {
                            object.set({text: name, fontSize: 7, objectCaching: false});
                        }
                    }
                }
            }
        }

        function padZero(str, len) {
            len = len || 2;
            const zeros = new Array(len).join('0');
            return (zeros + str).slice(-len);
        }
        
        function invertColor(hex) {
            let color = "#000000";
            if (hex != null && hex !== 'undefined' && hex != "") {
                if (hex.indexOf('#') === 0) {
                    hex = hex.slice(1);
                }
                // convert 3-digit hex to 6-digits.
                if (hex.length === 3) {
                    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                }
                if (hex.length !== 6) {
                    throw new Error('Invalid HEX color.');
                }
                const r = parseInt(hex.slice(0, 2), 16),
                    g = parseInt(hex.slice(2, 4), 16),
                    b = parseInt(hex.slice(4, 6), 16);

                color = (r * 0.299 + g * 0.587 + b * 0.114) > 186
                    ? '#000000'
                    : '#FFFFFF';
            }
            return color;
        }
        
        $scope.invertColor = function (hex) {
            return invertColor(hex);
        }
    }])

    .controller("SpaceItemCtrl", ['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
        $scope.item = item;
        if (item != null) {
            $scope.options = item.options;
        } else {
            $scope.options = {
                rows: 1,
                places: 5,
                firstRowNumber: 1,
                firstPlaceNumber: 1,
                placesDirection: "right",
                placesDirection2: "down",
                onlyPairNone: false,
                resetPlaceNumberByRow: true,
                positions_header: "down",
                color: $scope.zone_color
            };
        }
        $scope.ok = function () {
            $uibModalInstance.close($scope.options);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.delete = function () {
            $scope.deleteObject($scope.item);
            $uibModalInstance.dismiss('deleted');
        };
    }])

    .controller("SpaceTableCtrl", ['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
        $scope.item = item;

        if (item != null) {
            $scope.options = item.options;
        } else {
            $scope.options = {
                rows: 1,
                places: "8",
                places_left: 0,
                places_top: 6,
                places_right: 0,
                places_bottom: 6,
                type: "round",
                system_table: "cartesian",
                head_table: "no_head",
                type_presidency_table: "french",
                positions_header: "left"
            };
        }
        $scope.ok = function () {
            $uibModalInstance.close($scope.options);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.delete = function () {
            $scope.deleteObject($scope.item);
            $uibModalInstance.dismiss('deleted');
        };
    }])

    ;